export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: string; output: string; }
  AWSDateTime: { input: string; output: string; }
  AWSEmail: { input: string; output: string; }
  AWSIPAddress: { input: string; output: string; }
  AWSJSON: { input: string; output: string; }
  AWSPhone: { input: string; output: string; }
  AWSTime: { input: string; output: string; }
  AWSTimestamp: { input: number; output: number; }
  AWSURL: { input: string; output: string; }
  Long: { input: number; output: number; }
};

export type AcceptCustomerInvitation = {
  __typename?: 'AcceptCustomerInvitation';
  successful: Scalars['Boolean']['output'];
};

export type AcceptInvitationInput = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  invitationCode: Scalars['String']['input'];
};

export type AddDevicesToGroupInput = {
  deviceIds: Array<Scalars['ID']['input']>;
  groupId: Scalars['ID']['input'];
};

export type AllCleaningReports = {
  __typename?: 'AllCleaningReports';
  nodes: Array<CleaningReport>;
  pageInfo: PaginationMetadata;
};

export type AppVersion = {
  __typename?: 'AppVersion';
  minAppVersion: Scalars['String']['output'];
};

export enum AssetPermissionEnum {
  Edit = 'EDIT',
  FullPermission = 'FULL_PERMISSION',
  NoPermission = 'NO_PERMISSION',
  Read = 'READ'
}

export type AssignDeviceGroupsToScopeInput = {
  groupIds: Array<Scalars['ID']['input']>;
  scopeIds: Array<Scalars['ID']['input']>;
};

export type AssignMapGroupsToScopeInput = {
  groupIds: Array<Scalars['ID']['input']>;
  scopeIds: Array<Scalars['ID']['input']>;
};

export type AssignUsersToScopeInput = {
  roleId: Scalars['ID']['input'];
  scopeId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type AssignedDevices = {
  __typename?: 'AssignedDevices';
  assetPermission?: Maybe<AssetPermissionEnum>;
  createdAt: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  materialNumber: Scalars['String']['output'];
  name: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
  type: DeviceTypeName;
  updatedAt: Scalars['String']['output'];
};

export type AssignedDevicesInput = {
  createdAt: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  materialNumber: Scalars['String']['input'];
  name: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
  type: DeviceTypeName;
  updatedAt: Scalars['String']['input'];
};

export type AssignedMaps = {
  __typename?: 'AssignedMaps';
  assetPermission?: Maybe<AssetPermissionEnum>;
  createdAt: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  mapId: Scalars['ID']['output'];
  mapType: Scalars['String']['output'];
  materialNumber: Scalars['String']['output'];
  name: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type AssociateDevicesToMapInput = {
  associatedDevices: Array<AssociatedDevicesInput>;
  id: Scalars['ID']['input'];
};

export type AssociateDevicesToMapResponse = {
  __typename?: 'AssociateDevicesToMapResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AssociateMapsToGroupInput = {
  id: Scalars['ID']['input'];
  mapIds: Array<Scalars['ID']['input']>;
};

export type AssociateMapsToGroupResponse = {
  __typename?: 'AssociateMapsToGroupResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AssociatedDevices = {
  __typename?: 'AssociatedDevices';
  materialNumber?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
};

export type AssociatedDevicesInput = {
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};

export type BRangeCleaningCommandInput = {
  commandType: BRangeCleaningCommandType;
  materialNumber: Scalars['String']['input'];
  routeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  routineId?: InputMaybe<Scalars['Int']['input']>;
  serialNumber: Scalars['String']['input'];
};

export enum BRangeCleaningCommandType {
  MissionDriveBackAndCancel = 'MISSION_DRIVE_BACK_AND_CANCEL',
  MissionDriveBackAndSkip = 'MISSION_DRIVE_BACK_AND_SKIP',
  MissionInstinctiveDocking = 'MISSION_INSTINCTIVE_DOCKING',
  MissionPause = 'MISSION_PAUSE',
  MissionResume = 'MISSION_RESUME',
  MissionStop = 'MISSION_STOP',
  StartCleaning = 'START_CLEANING'
}

export type BatteryPack = {
  __typename?: 'BatteryPack';
  active: Scalars['Float']['output'];
  cycleCount: Scalars['Float']['output'];
  fullChargeCapacity: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  remainingCapacity: Scalars['Float']['output'];
  stateOfCharge: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  temperature: Scalars['Float']['output'];
};

export type BatteryPackInput = {
  active?: InputMaybe<Scalars['Float']['input']>;
  cycleCount?: InputMaybe<Scalars['Float']['input']>;
  fullChargeCapacity?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  remainingCapacity?: InputMaybe<Scalars['Float']['input']>;
  stateOfCharge?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
};

export type BatteryPackUpdate = {
  __typename?: 'BatteryPackUpdate';
  active?: Maybe<Scalars['Float']['output']>;
  cycleCount?: Maybe<Scalars['Float']['output']>;
  fullChargeCapacity?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  remainingCapacity?: Maybe<Scalars['Float']['output']>;
  stateOfCharge?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
};

export enum Cv50Commands {
  Beep = 'BEEP',
  Blink = 'BLINK',
  CleaningProfileDelete = 'CLEANING_PROFILE_DELETE',
  ScheduleCleaningProfileDelete = 'SCHEDULE_CLEANING_PROFILE_DELETE',
  ScheduleCleaningProfileSet = 'SCHEDULE_CLEANING_PROFILE_SET',
  SettingsAutoSideBroomSpeed = 'SETTINGS_AUTO_SIDE_BROOM_SPEED',
  SettingsBatteryTheft = 'SETTINGS_BATTERY_THEFT',
  SettingsBluetooth = 'SETTINGS_BLUETOOTH',
  SettingsCableDetection = 'SETTINGS_CABLE_DETECTION',
  SettingsCarpetDetection = 'SETTINGS_CARPET_DETECTION',
  SettingsCleaningMode = 'SETTINGS_CLEANING_MODE',
  SettingsHmiLanguage = 'SETTINGS_HMI_LANGUAGE',
  SettingsLights = 'SETTINGS_LIGHTS',
  SettingsLock = 'SETTINGS_LOCK',
  SettingsLockcode = 'SETTINGS_LOCKCODE',
  SettingsQuickCleaningMode = 'SETTINGS_QUICK_CLEANING_MODE',
  SettingsReset = 'SETTINGS_RESET',
  SettingsRobotName = 'SETTINGS_ROBOT_NAME',
  SettingsSoundOperating = 'SETTINGS_SOUND_OPERATING',
  SettingsSoundVolume = 'SETTINGS_SOUND_VOLUME',
  SettingsSoundWarning = 'SETTINGS_SOUND_WARNING',
  SettingsTheftProtection = 'SETTINGS_THEFT_PROTECTION',
  SettingsWifiConnect = 'SETTINGS_WIFI_CONNECT',
  SettingsWifiDelete = 'SETTINGS_WIFI_DELETE',
  Update = 'UPDATE',
  UploadLog = 'UPLOAD_LOG',
  UploadMap = 'UPLOAD_MAP'
}

export type CategorySubscriptionsQueryResponse = {
  __typename?: 'CategorySubscriptionsQueryResponse';
  categories: Array<Maybe<NotificationCategoryTypeEnum>>;
};

export type ChangeBluetoothConnectivityInput = {
  enabled: Scalars['Boolean']['input'];
  materialNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export type ChangeDeviceLanguage = {
  __typename?: 'ChangeDeviceLanguage';
  newLanguage: DeviceLanguage;
  oldLanguage: DeviceLanguage;
};

export type ChangeDeviceLanguageInput = {
  language: DeviceLanguage;
  materialNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export type ChangeDeviceName = {
  __typename?: 'ChangeDeviceName';
  newName: Scalars['String']['output'];
  oldName: Scalars['String']['output'];
};

export type ChangeDeviceNameInput = {
  materialNumber: Scalars['String']['input'];
  name: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export type ChangeDevicePin = {
  __typename?: 'ChangeDevicePin';
  successful: Scalars['Boolean']['output'];
};

export type ChangeDevicePinInput = {
  materialNumber: Scalars['String']['input'];
  pin: Scalars['Int']['input'];
  serialNumber: Scalars['String']['input'];
};

export type ChangeDeviceSound = {
  __typename?: 'ChangeDeviceSound';
  successful: Scalars['Boolean']['output'];
};

export type ChangeDeviceSoundInput = {
  materialNumber: Scalars['String']['input'];
  operatingSound?: InputMaybe<Scalars['Boolean']['input']>;
  serialNumber: Scalars['String']['input'];
  volume?: InputMaybe<Scalars['Int']['input']>;
  warningSound?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChangeFirmwareUpdateMode = {
  __typename?: 'ChangeFirmwareUpdateMode';
  successful: Scalars['Boolean']['output'];
};

export type ChangeFirmwareUpdateModeInput = {
  automatic: Scalars['Boolean']['input'];
  materialNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export type ChangePasswordInput = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

export type ChangePasswordResponse = {
  __typename?: 'ChangePasswordResponse';
  code?: Maybe<Scalars['Int']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
};

export type ClaimDeviceInput = {
  claimingCode: Scalars['String']['input'];
  deviceGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  materialNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export type ClaimDeviceSubscription = {
  __typename?: 'ClaimDeviceSubscription';
  customerId?: Maybe<Scalars['String']['output']>;
  dateOfClaim?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isConfirmed?: Maybe<Scalars['Boolean']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  subscriptionMode?: Maybe<SubscriptionMode>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ClaimDeviceSubscriptionInput = {
  customerId: Scalars['String']['input'];
  dateOfClaim?: InputMaybe<Scalars['String']['input']>;
  deviceId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  isConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  materialNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
  subscriptionMode?: InputMaybe<SubscriptionMode>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type ClaimedDevice = {
  __typename?: 'ClaimedDevice';
  customerId: Scalars['String']['output'];
  deviceId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  materialNumber: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
};

export enum ClaimingValidationResultEnum {
  AlreadyClaimed = 'ALREADY_CLAIMED',
  AlreadyClaimedSelf = 'ALREADY_CLAIMED_SELF',
  ClaimingPossible = 'CLAIMING_POSSIBLE',
  Deactivated = 'DEACTIVATED',
  NotFound = 'NOT_FOUND',
  NotSupported = 'NOT_SUPPORTED'
}

export enum CleaningActivityEnum {
  Cleaning = 'CLEANING',
  Exploration = 'EXPLORATION'
}

export enum CleaningActivityTriggerEnum {
  Autonomous = 'AUTONOMOUS',
  Manual = 'MANUAL',
  Scheduled = 'SCHEDULED'
}

export enum CleaningIssueLevelEnum {
  Critical = 'Critical',
  Info = 'Info',
  Major = 'Major',
  Minor = 'Minor'
}

export enum CleaningModeEnum {
  Area = 'AREA',
  Spot = 'SPOT',
  WholeMap = 'WHOLE_MAP'
}

export type CleaningReport = {
  __typename?: 'CleaningReport';
  activity: CleaningActivityEnum;
  activityTrigger: CleaningActivityTriggerEnum;
  cleanedArea: Scalars['Int']['output'];
  cleanedTime: Scalars['Int']['output'];
  cleaningGroupId?: Maybe<Scalars['String']['output']>;
  consumption?: Maybe<CleaningReportConsumption>;
  currentCleaningZone?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['String']['output'];
  deviceDetails: CleaningReportDeviceDetails;
  deviceFirmware: Scalars['String']['output'];
  deviceId: Scalars['String']['output'];
  deviceName: Scalars['String']['output'];
  deviceType: DeviceTypeName;
  doneCleaningZones?: Maybe<Array<Scalars['String']['output']>>;
  endTime?: Maybe<Scalars['String']['output']>;
  general: CleaningReportGeneral;
  id: Scalars['String']['output'];
  issues: Array<CleaningReportIssue>;
  mapGroupName?: Maybe<Scalars['String']['output']>;
  mapId?: Maybe<Scalars['String']['output']>;
  mapInfo?: Maybe<CleaningReportMapInfo>;
  mapName?: Maybe<Scalars['String']['output']>;
  materialNumber: Scalars['String']['output'];
  nextCleaningZone?: Maybe<Scalars['String']['output']>;
  remainingArea: Scalars['Int']['output'];
  remainingCleaningZones?: Maybe<Array<Scalars['String']['output']>>;
  remainingTime: Scalars['Int']['output'];
  reportType: CleaningReportTypeEnum;
  routeCount?: Maybe<Scalars['Int']['output']>;
  routeIndex?: Maybe<Scalars['Int']['output']>;
  schedule?: Maybe<CleaningReportSchedule>;
  scheduleId?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<CleaningScopeEnum>;
  serialNumber: Scalars['String']['output'];
  spotCoordinates?: Maybe<CleaningSpot>;
  startTime: Scalars['String']['output'];
  status: CleaningStatusEnum;
  suctionMode: Scalars['Int']['output'];
};

export type CleaningReportConnection = {
  __typename?: 'CleaningReportConnection';
  nodes: Array<CleaningReport>;
  pageInfo: PaginationMetadata;
};

export type CleaningReportConnectionInput = {
  nodes: Array<CleaningReportInput>;
};

export type CleaningReportConsumption = {
  __typename?: 'CleaningReportConsumption';
  battery?: Maybe<Scalars['Float']['output']>;
  detergents?: Maybe<Scalars['Float']['output']>;
  water?: Maybe<Scalars['Float']['output']>;
};

export type CleaningReportConsumptionInput = {
  battery?: InputMaybe<Scalars['Float']['input']>;
  detergents?: InputMaybe<Scalars['Float']['input']>;
  water?: InputMaybe<Scalars['Float']['input']>;
};

export type CleaningReportDeviceDetails = {
  __typename?: 'CleaningReportDeviceDetails';
  deviceFirmware?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<DeviceTypeName>;
};

export type CleaningReportDeviceDetailsInput = {
  deviceFirmware?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  deviceType?: InputMaybe<DeviceTypeName>;
};

export type CleaningReportGeneral = {
  __typename?: 'CleaningReportGeneral';
  activity?: Maybe<CleaningActivityEnum>;
  activityTrigger?: Maybe<CleaningActivityTriggerEnum>;
  cleanedArea: Scalars['Int']['output'];
  cleanedTime: Scalars['Int']['output'];
  coveredArea?: Maybe<Scalars['Int']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  pathCoverage: Scalars['Float']['output'];
  remainingArea?: Maybe<Scalars['Int']['output']>;
  remainingTime?: Maybe<Scalars['Int']['output']>;
  suctionMode?: Maybe<Scalars['Int']['output']>;
  uncleanedArea?: Maybe<Scalars['Int']['output']>;
};

export type CleaningReportGeneralInput = {
  activity?: InputMaybe<CleaningActivityEnum>;
  activityTrigger?: InputMaybe<CleaningActivityTriggerEnum>;
  cleanedArea?: InputMaybe<Scalars['Int']['input']>;
  cleanedTime?: InputMaybe<Scalars['Int']['input']>;
  coveredArea?: InputMaybe<Scalars['Int']['input']>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  pathCoverage?: InputMaybe<Scalars['Float']['input']>;
  remainingArea?: InputMaybe<Scalars['Int']['input']>;
  remainingTime?: InputMaybe<Scalars['Int']['input']>;
  suctionMode?: InputMaybe<Scalars['Int']['input']>;
  uncleanedArea?: InputMaybe<Scalars['Int']['input']>;
};

export type CleaningReportInput = {
  activity?: InputMaybe<CleaningActivityEnum>;
  activityTrigger?: InputMaybe<CleaningActivityTriggerEnum>;
  cleanedArea?: InputMaybe<Scalars['Int']['input']>;
  cleanedTime?: InputMaybe<Scalars['Int']['input']>;
  consumption?: InputMaybe<CleaningReportConsumptionInput>;
  currentCleaningZone?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  deviceDetails?: InputMaybe<CleaningReportDeviceDetailsInput>;
  deviceFirmware?: InputMaybe<Scalars['String']['input']>;
  deviceId: Scalars['String']['input'];
  deviceName?: InputMaybe<Scalars['String']['input']>;
  deviceType?: InputMaybe<DeviceTypeName>;
  doneCleaningZones?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  general?: InputMaybe<CleaningReportGeneralInput>;
  id: Scalars['String']['input'];
  issues?: InputMaybe<Array<CleaningReportIssueInput>>;
  mapGroupName?: InputMaybe<Scalars['String']['input']>;
  mapId?: InputMaybe<Scalars['String']['input']>;
  mapInfo?: InputMaybe<CleaningReportMapInfoInput>;
  mapName?: InputMaybe<Scalars['String']['input']>;
  materialNumber: Scalars['String']['input'];
  nextCleaningZone?: InputMaybe<Scalars['String']['input']>;
  remainingArea?: InputMaybe<Scalars['Int']['input']>;
  remainingCleaningZones?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  remainingTime?: InputMaybe<Scalars['Int']['input']>;
  reportType?: InputMaybe<CleaningReportTypeEnum>;
  routeCount?: InputMaybe<Scalars['Int']['input']>;
  routeIndex?: InputMaybe<Scalars['Int']['input']>;
  schedule?: InputMaybe<CleaningReportScheduleInput>;
  scheduleId?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<CleaningScopeEnum>;
  serialNumber: Scalars['String']['input'];
  spotCoordinates?: InputMaybe<CleaningSpotInput>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CleaningStatusEnum>;
  suctionMode?: InputMaybe<Scalars['Int']['input']>;
};

export type CleaningReportIssue = {
  __typename?: 'CleaningReportIssue';
  code: Scalars['String']['output'];
  coordinateX: Scalars['Int']['output'];
  coordinateY: Scalars['Int']['output'];
  level: CleaningIssueLevelEnum;
  timestamp: Scalars['String']['output'];
};

export type CleaningReportIssueInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  coordinateX?: InputMaybe<Scalars['Int']['input']>;
  coordinateY?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<CleaningIssueLevelEnum>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
};

export type CleaningReportIssueUpdate = {
  __typename?: 'CleaningReportIssueUpdate';
  code?: Maybe<Scalars['String']['output']>;
  coordinateX?: Maybe<Scalars['Int']['output']>;
  coordinateY?: Maybe<Scalars['Int']['output']>;
  level?: Maybe<CleaningIssueLevelEnum>;
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type CleaningReportMap = {
  __typename?: 'CleaningReportMap';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type CleaningReportMapInfo = {
  __typename?: 'CleaningReportMapInfo';
  cleaningGroupId?: Maybe<Scalars['String']['output']>;
  mapGroupName?: Maybe<Scalars['String']['output']>;
  mapId?: Maybe<Scalars['String']['output']>;
  mapName?: Maybe<Scalars['String']['output']>;
  repeatPathId?: Maybe<Scalars['String']['output']>;
  routineId?: Maybe<Scalars['String']['output']>;
};

export type CleaningReportMapInfoInput = {
  cleaningGroupId?: InputMaybe<Scalars['String']['input']>;
  mapGroupName?: InputMaybe<Scalars['String']['input']>;
  mapId?: InputMaybe<Scalars['String']['input']>;
  mapName?: InputMaybe<Scalars['String']['input']>;
  repeatPathId?: InputMaybe<Scalars['String']['input']>;
  routineId?: InputMaybe<Scalars['String']['input']>;
};

export type CleaningReportSchedule = {
  __typename?: 'CleaningReportSchedule';
  cleaningZones?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  mapId: Scalars['ID']['output'];
  repetition: CleaningScheduleRepetitionEnum;
  startTime: Scalars['String']['output'];
  suction: Scalars['Int']['output'];
  weekdays: Array<Scalars['Int']['output']>;
};

export type CleaningReportScheduleInput = {
  cleaningZones?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  mapId?: InputMaybe<Scalars['ID']['input']>;
  repetition?: InputMaybe<CleaningScheduleRepetitionEnum>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  suction?: InputMaybe<Scalars['Int']['input']>;
  weekdays?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type CleaningReportScheduleUpdate = {
  __typename?: 'CleaningReportScheduleUpdate';
  cleaningZones?: Maybe<Array<Scalars['String']['output']>>;
  id?: Maybe<Scalars['ID']['output']>;
  mapId?: Maybe<Scalars['ID']['output']>;
  repetition?: Maybe<CleaningScheduleRepetitionEnum>;
  startTime?: Maybe<Scalars['String']['output']>;
  suction?: Maybe<Scalars['Int']['output']>;
  weekdays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type CleaningReportTimeFilter = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export enum CleaningReportTypeEnum {
  Route = 'ROUTE',
  Routine = 'ROUTINE',
  RoutineRoute = 'ROUTINE_ROUTE'
}

export type CleaningReportUpdate = {
  __typename?: 'CleaningReportUpdate';
  activity?: Maybe<CleaningActivityEnum>;
  activityTrigger?: Maybe<CleaningActivityTriggerEnum>;
  cleanedArea?: Maybe<Scalars['Int']['output']>;
  cleanedTime?: Maybe<Scalars['Int']['output']>;
  cleaningGroupId?: Maybe<Scalars['String']['output']>;
  consumption?: Maybe<CleaningReportConsumption>;
  currentCleaningZone?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  deviceDetails?: Maybe<CleaningReportDeviceDetails>;
  deviceFirmware?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<DeviceTypeName>;
  doneCleaningZones?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  endTime?: Maybe<Scalars['String']['output']>;
  general?: Maybe<CleaningReportUpdateGeneral>;
  id?: Maybe<Scalars['String']['output']>;
  issues?: Maybe<Array<CleaningReportIssue>>;
  mapGroupName?: Maybe<Scalars['String']['output']>;
  mapId?: Maybe<Scalars['String']['output']>;
  mapInfo?: Maybe<CleaningReportMapInfo>;
  mapName?: Maybe<Scalars['String']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  nextCleaningZone?: Maybe<Scalars['String']['output']>;
  remainingArea?: Maybe<Scalars['Int']['output']>;
  remainingCleaningZones?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  remainingTime?: Maybe<Scalars['Int']['output']>;
  reportType?: Maybe<CleaningReportTypeEnum>;
  routeCount?: Maybe<Scalars['Int']['output']>;
  routeIndex?: Maybe<Scalars['Int']['output']>;
  schedule?: Maybe<CleaningReportScheduleUpdate>;
  scheduleId?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<CleaningScopeEnum>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  spotCoordinates?: Maybe<CleaningSpot>;
  startTime?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CleaningStatusEnum>;
  suctionMode?: Maybe<Scalars['Int']['output']>;
};

export type CleaningReportUpdateGeneral = {
  __typename?: 'CleaningReportUpdateGeneral';
  activity?: Maybe<CleaningActivityEnum>;
  activityTrigger?: Maybe<CleaningActivityTriggerEnum>;
  cleanedArea?: Maybe<Scalars['Int']['output']>;
  cleanedTime?: Maybe<Scalars['Int']['output']>;
  coveredArea?: Maybe<Scalars['Int']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  pathCoverage?: Maybe<Scalars['Float']['output']>;
  remainingArea?: Maybe<Scalars['Int']['output']>;
  remainingTime?: Maybe<Scalars['Int']['output']>;
  suctionMode?: Maybe<Scalars['Int']['output']>;
  uncleanedArea?: Maybe<Scalars['Int']['output']>;
};

export type CleaningSchedule = {
  __typename?: 'CleaningSchedule';
  active: Scalars['Boolean']['output'];
  cleaningMode?: Maybe<CleaningModeEnum>;
  cleaningZones?: Maybe<Array<Scalars['String']['output']>>;
  deviceId: Scalars['String']['output'];
  deviceName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastExecution?: Maybe<Scalars['String']['output']>;
  mapGroupName?: Maybe<Scalars['String']['output']>;
  mapId: Scalars['String']['output'];
  mapName: Scalars['String']['output'];
  repetition: CleaningScheduleRepetitionEnum;
  startTime: Scalars['String']['output'];
  suction: CleaningSuctionEnum;
  weekdays: Array<Scalars['Int']['output']>;
};

export type CleaningScheduleConnection = {
  __typename?: 'CleaningScheduleConnection';
  nodes: Array<CleaningSchedule>;
};

export type CleaningScheduleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  cleaningMode?: InputMaybe<CleaningModeEnum>;
  cleaningZones?: InputMaybe<Array<Scalars['String']['input']>>;
  customerId: Scalars['String']['input'];
  deviceId?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastExecution?: InputMaybe<Scalars['String']['input']>;
  mapGroupName?: InputMaybe<Scalars['String']['input']>;
  mapId: Scalars['String']['input'];
  mapName?: InputMaybe<Scalars['String']['input']>;
  materialNumber: Scalars['String']['input'];
  mode?: InputMaybe<SubscriptionMode>;
  repetition?: InputMaybe<CleaningScheduleRepetitionEnum>;
  serialNumber: Scalars['String']['input'];
  startTime?: InputMaybe<Scalars['String']['input']>;
  subscriptionMode?: InputMaybe<SubscriptionMode>;
  suction?: InputMaybe<CleaningSuctionEnum>;
  weekdays?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type CleaningScheduleOccurrence = {
  __typename?: 'CleaningScheduleOccurrence';
  cleaningMode?: Maybe<CleaningModeEnum>;
  cleaningZones?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  map?: Maybe<Map>;
  route?: Maybe<Route>;
  routine?: Maybe<Routine>;
  rrule: Scalars['String']['output'];
  scheduleId: Scalars['ID']['output'];
  scheduleName: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  suction?: Maybe<CleaningSuctionEnum>;
};

export enum CleaningScheduleRepetitionEnum {
  Daily = 'DAILY',
  OneTime = 'ONE_TIME',
  Weekly = 'WEEKLY'
}

export type CleaningScheduleUpdate = {
  __typename?: 'CleaningScheduleUpdate';
  active?: Maybe<Scalars['Boolean']['output']>;
  cleaningMode?: Maybe<CleaningModeEnum>;
  cleaningZones?: Maybe<Array<Scalars['String']['output']>>;
  customerId?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastExecution?: Maybe<Scalars['String']['output']>;
  mapGroupName?: Maybe<Scalars['String']['output']>;
  mapId?: Maybe<Scalars['String']['output']>;
  mapName?: Maybe<Scalars['String']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<SubscriptionMode>;
  repetition?: Maybe<CleaningScheduleRepetitionEnum>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  subscriptionMode?: Maybe<SubscriptionMode>;
  suction?: Maybe<CleaningSuctionEnum>;
  weekdays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type CleaningScheduleV2 = {
  __typename?: 'CleaningScheduleV2';
  cleaningMode?: Maybe<CleaningModeEnum>;
  cleaningZones?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  deviceId: Scalars['ID']['output'];
  deviceName: Scalars['String']['output'];
  firstExecution?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastExecution?: Maybe<Scalars['String']['output']>;
  mapGroupName?: Maybe<Scalars['String']['output']>;
  mapId?: Maybe<Scalars['ID']['output']>;
  mapName?: Maybe<Scalars['String']['output']>;
  materialNumber: Scalars['String']['output'];
  name: Scalars['String']['output'];
  routeId?: Maybe<Scalars['ID']['output']>;
  routeName?: Maybe<Scalars['String']['output']>;
  routineId?: Maybe<Scalars['ID']['output']>;
  routineName?: Maybe<Scalars['String']['output']>;
  rrule: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
  status: ScheduleStatus;
  subscriptionMode?: Maybe<SubscriptionMode>;
  suction: CleaningSuctionEnum;
  type: ScheduleType;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type CleaningScheduleV2Connection = {
  __typename?: 'CleaningScheduleV2Connection';
  nodes: Array<CleaningScheduleV2>;
  pageInfo: PageInfo;
};

export type CleaningScheduleV2Input = {
  cleaningMode?: InputMaybe<CleaningModeEnum>;
  cleaningZones?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  deviceId: Scalars['ID']['input'];
  deviceName: Scalars['String']['input'];
  firstExecution?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastExecution?: InputMaybe<Scalars['String']['input']>;
  mapGroupName?: InputMaybe<Scalars['String']['input']>;
  mapId?: InputMaybe<Scalars['ID']['input']>;
  mapName?: InputMaybe<Scalars['String']['input']>;
  materialNumber: Scalars['String']['input'];
  name: Scalars['String']['input'];
  routeId?: InputMaybe<Scalars['ID']['input']>;
  routeName?: InputMaybe<Scalars['String']['input']>;
  routineId?: InputMaybe<Scalars['ID']['input']>;
  routineName?: InputMaybe<Scalars['String']['input']>;
  rrule: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
  status: ScheduleStatus;
  subscriptionMode: SubscriptionMode;
  suction: CleaningSuctionEnum;
  type: ScheduleType;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type CleaningScheduleV2Order = {
  direction: OrderDirection;
  field: CleaningScheduleV2OrderField;
};

export enum CleaningScheduleV2OrderField {
  CreatedAt = 'CREATED_AT'
}

export enum CleaningScopeEnum {
  Area = 'AREA',
  Spot = 'SPOT',
  WholeMap = 'WHOLE_MAP'
}

export type CleaningSpot = {
  __typename?: 'CleaningSpot';
  x1: Scalars['Float']['output'];
  x2: Scalars['Float']['output'];
  xStart: Scalars['Float']['output'];
  y1: Scalars['Float']['output'];
  y2: Scalars['Float']['output'];
  yStart: Scalars['Float']['output'];
};

export type CleaningSpotInput = {
  x1: Scalars['Float']['input'];
  x2: Scalars['Float']['input'];
  xStart: Scalars['Float']['input'];
  y1: Scalars['Float']['input'];
  y2: Scalars['Float']['input'];
  yStart: Scalars['Float']['input'];
};

export enum CleaningStatusEnum {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Finished = 'FINISHED',
  Interrupted = 'INTERRUPTED',
  Unknown = 'UNKNOWN',
  Working = 'WORKING'
}

export enum CleaningSuctionEnum {
  Boost = 'BOOST',
  Eco = 'ECO',
  Normal = 'NORMAL'
}

export type CloneMapInput = {
  id: Scalars['ID']['input'];
  newId?: InputMaybe<Scalars['ID']['input']>;
  newName?: InputMaybe<Scalars['String']['input']>;
};

export type CloneMapResponse = {
  __typename?: 'CloneMapResponse';
  mapId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type Command = {
  data: CommandData;
  type: Cv50Commands;
};

export type CommandData = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  ap_creds?: InputMaybe<Scalars['String']['input']>;
  cleaningMode?: InputMaybe<Scalars['Int']['input']>;
  cleaningZones?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['Int']['input']>;
  confirm?: InputMaybe<Scalars['Int']['input']>;
  firmware?: InputMaybe<Scalars['Int']['input']>;
  hmiLanguage?: InputMaybe<Scalars['String']['input']>;
  mapId?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<CleaningSuctionEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  preset?: InputMaybe<Scalars['String']['input']>;
  repetition?: InputMaybe<CleaningScheduleRepetitionEnum>;
  robotName?: InputMaybe<Scalars['String']['input']>;
  scheduleId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['Int']['input']>;
  soundVolume?: InputMaybe<Scalars['Int']['input']>;
  spot?: InputMaybe<CleaningSpotInput>;
  ssid?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  weekDays?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type CommandDetail = {
  __typename?: 'CommandDetail';
  data?: Maybe<CommandDetailData>;
  type?: Maybe<Cv50Commands>;
};

export type CommandDetailData = {
  __typename?: 'CommandDetailData';
  active?: Maybe<Scalars['Boolean']['output']>;
  cleaningMode?: Maybe<Scalars['Int']['output']>;
  cleaningZones?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  code?: Maybe<Scalars['Int']['output']>;
  confirm?: Maybe<Scalars['Int']['output']>;
  firmware?: Maybe<Scalars['Int']['output']>;
  mapId?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<CleaningSuctionEnum>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  preset?: Maybe<Scalars['String']['output']>;
  repetition?: Maybe<CleaningScheduleRepetitionEnum>;
  robotName?: Maybe<Scalars['String']['output']>;
  scheduleId?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<Scalars['Int']['output']>;
  soundVolume?: Maybe<Scalars['Int']['output']>;
  spot?: Maybe<CleaningSpot>;
  ssid?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  weekDays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type CommandDetailDataInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  cleaningMode?: InputMaybe<Scalars['Int']['input']>;
  cleaningZones?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['Int']['input']>;
  confirm?: InputMaybe<Scalars['Int']['input']>;
  firmware?: InputMaybe<Scalars['Int']['input']>;
  hmiLanguage?: InputMaybe<Scalars['String']['input']>;
  mapId?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<CleaningSuctionEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  preset?: InputMaybe<Scalars['String']['input']>;
  repetition?: InputMaybe<CleaningScheduleRepetitionEnum>;
  robotName?: InputMaybe<Scalars['String']['input']>;
  scheduleId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['Int']['input']>;
  soundVolume?: InputMaybe<Scalars['Int']['input']>;
  spot?: InputMaybe<CleaningSpotInput>;
  ssid?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  weekDays?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type CommandDetailInput = {
  data?: InputMaybe<CommandDetailDataInput>;
  type?: InputMaybe<Cv50Commands>;
};

export type CommandSendInput = {
  command: Command;
  deviceId: Scalars['String']['input'];
};

export type CommandStatus = {
  __typename?: 'CommandStatus';
  createdAt?: Maybe<Scalars['String']['output']>;
  details?: Maybe<CommandDetail>;
  executionId: Scalars['String']['output'];
  status?: Maybe<CommandStatusEnum>;
  statusDetail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  validationError?: Maybe<Scalars['String']['output']>;
};

export type CommandStatusConnection = {
  __typename?: 'CommandStatusConnection';
  nodes: Array<CommandStatus>;
  pageInfo: PaginationMetadata;
};

export type CommandStatusConnectionInput = {
  nodes: Array<CommandStatusInput>;
};

export enum CommandStatusEnum {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Requested = 'REQUESTED',
  Succeeded = 'SUCCEEDED'
}

export type CommandStatusInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<CommandDetailInput>;
  executionId: Scalars['String']['input'];
  status?: InputMaybe<CommandStatusEnum>;
  statusDetail?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyOnboarding = {
  type: Scalars['String']['output'];
};

export type CompanyOnboardingInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  invitationCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  type: CompanyOnboardingInputEnum;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export enum CompanyOnboardingInputEnum {
  CompanyDetails = 'COMPANY_DETAILS',
  InvitationCode = 'INVITATION_CODE'
}

export type ConnectedCustomerInvitation = {
  __typename?: 'ConnectedCustomerInvitation';
  nodes: Array<CustomerInvitation>;
};

export type CreateCustomRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  permissions: RolePermissionsInput;
  scopeId: Scalars['ID']['input'];
};

export type CreateDeviceGroupInput = {
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  scopeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateInvitationInput = {
  roleId?: InputMaybe<Scalars['String']['input']>;
  scopeId?: InputMaybe<Scalars['String']['input']>;
  secondsValid?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateMapGroupInput = {
  mapIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  scopeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateScheduleInput = {
  cleaningZones?: InputMaybe<Array<Scalars['String']['input']>>;
  mapId?: InputMaybe<Scalars['ID']['input']>;
  materialNumber: Scalars['String']['input'];
  name: Scalars['String']['input'];
  routeId?: InputMaybe<Scalars['ID']['input']>;
  routineId?: InputMaybe<Scalars['ID']['input']>;
  rrule: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
  suction?: InputMaybe<CleaningSuctionEnum>;
};

export type CreateScopeInput = {
  deviceGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  mapGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  memberships?: InputMaybe<Array<MembershipInput>>;
  name: Scalars['String']['input'];
};

export type CustomRole = {
  __typename?: 'CustomRole';
  createdAt: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isReadOnly: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: Permissions;
  scopeId: Scalars['ID']['output'];
  scopeName: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type Customer = {
  __typename?: 'Customer';
  customerId: Scalars['String']['output'];
};

export type CustomerInformation = {
  __typename?: 'CustomerInformation';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  users: Array<CustomerUser>;
};

export type CustomerInvitation = {
  __typename?: 'CustomerInvitation';
  createdAt: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitationCode: Scalars['String']['output'];
  roleId?: Maybe<Scalars['String']['output']>;
  scopeId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  validUntil?: Maybe<Scalars['String']['output']>;
};

export type CustomerUser = {
  __typename?: 'CustomerUser';
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isAppUser: Scalars['Boolean']['output'];
  lastname: Scalars['String']['output'];
};

export type DeleteCustomRoleInput = {
  roleId: Scalars['ID']['input'];
};

export type DeleteDeviceGroupInput = {
  id: Scalars['ID']['input'];
};

export type DeleteMapGroupInput = {
  id: Scalars['ID']['input'];
};

export type DeleteMapGroupResponse = {
  __typename?: 'DeleteMapGroupResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteMapInput = {
  mapId: Scalars['ID']['input'];
};

export type DeleteMapResponse = {
  __typename?: 'DeleteMapResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteScheduleInput = {
  applyToFollowing?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  occurrence?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteScopeInput = {
  scopeId: Scalars['ID']['input'];
};

export type Device = {
  __typename?: 'Device';
  cleaningReports?: Maybe<CleaningReportConnection>;
  cleaningSchedules?: Maybe<CleaningScheduleConnection>;
  commands?: Maybe<CommandStatusConnection>;
  createdAt: Scalars['String']['output'];
  currentCleaningReport?: Maybe<CleaningReport>;
  customerId: Scalars['String']['output'];
  firmwareDetail?: Maybe<DeviceFirmwareDetail>;
  id: Scalars['ID']['output'];
  lastCleaningReport?: Maybe<CleaningReport>;
  lastOnline: Scalars['String']['output'];
  maps?: Maybe<DeviceMap>;
  materialNumber: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nextScheduledTask?: Maybe<NextCleaningSchedule>;
  notifications?: Maybe<NotificationConnectionWithoutPaginationSettings>;
  permission?: Maybe<UserAssetPermission>;
  producedRobotId: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
  settings?: Maybe<DeviceSettings>;
  state?: Maybe<DeviceState>;
  type: DeviceTypeName;
  updateAvailable: Scalars['Boolean']['output'];
  updatedAt: Scalars['String']['output'];
  wifiDetail?: Maybe<DeviceWifiNetworkDetail>;
};


export type DeviceCleaningReportsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type DeviceCommandsArgs = {
  filter?: InputMaybe<FilterInput>;
};

export type DeviceActions = {
  __typename?: 'DeviceActions';
  canAdd: Scalars['Boolean']['output'];
  mustSelectScope: Scalars['Boolean']['output'];
};

export type DeviceCellularStatus = {
  __typename?: 'DeviceCellularStatus';
  cid: Scalars['Int']['output'];
  iccid: Scalars['String']['output'];
  imei: Scalars['String']['output'];
  imsi: Scalars['String']['output'];
  mcc: Scalars['Int']['output'];
  mnc: Scalars['Int']['output'];
  ss: Scalars['Int']['output'];
  ta: Scalars['Int']['output'];
  tac: Scalars['Int']['output'];
};

export type DeviceCellularStatusInput = {
  cid?: InputMaybe<Scalars['Int']['input']>;
  iccid?: InputMaybe<Scalars['String']['input']>;
  imei?: InputMaybe<Scalars['String']['input']>;
  imsi?: InputMaybe<Scalars['String']['input']>;
  mcc?: InputMaybe<Scalars['Int']['input']>;
  mnc?: InputMaybe<Scalars['Int']['input']>;
  ss?: InputMaybe<Scalars['Int']['input']>;
  ta?: InputMaybe<Scalars['Int']['input']>;
  tac?: InputMaybe<Scalars['Int']['input']>;
};

export type DeviceCellularStatusUpdate = {
  __typename?: 'DeviceCellularStatusUpdate';
  cid?: Maybe<Scalars['Int']['output']>;
  iccid?: Maybe<Scalars['String']['output']>;
  imei?: Maybe<Scalars['String']['output']>;
  imsi?: Maybe<Scalars['String']['output']>;
  mcc?: Maybe<Scalars['Int']['output']>;
  mnc?: Maybe<Scalars['Int']['output']>;
  ss?: Maybe<Scalars['Int']['output']>;
  ta?: Maybe<Scalars['Int']['output']>;
  tac?: Maybe<Scalars['Int']['output']>;
};

export type DeviceConnection = {
  __typename?: 'DeviceConnection';
  nodes: Array<Device>;
  pageInfo: PaginationMetadata;
};

export type DeviceFirmwareDetail = {
  __typename?: 'DeviceFirmwareDetail';
  currentVersion: Scalars['String']['output'];
  lastUpdated: Scalars['String']['output'];
};

export type DeviceFirmwareDetailInput = {
  currentVersion?: InputMaybe<Scalars['String']['input']>;
  lastUpdated?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceFirmwareDetailUpdate = {
  __typename?: 'DeviceFirmwareDetailUpdate';
  currentVersion?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
};

export type DeviceFirmwareUpdateSubscription = {
  __typename?: 'DeviceFirmwareUpdateSubscription';
  customerId?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  firmwareReleaseId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subscriptionMode?: Maybe<SubscriptionMode>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type DeviceFirmwareUpdateSubscriptionInput = {
  customerId: Scalars['String']['input'];
  deviceId?: InputMaybe<Scalars['String']['input']>;
  firmwareReleaseId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subscriptionMode?: InputMaybe<SubscriptionMode>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceGroup = {
  __typename?: 'DeviceGroup';
  createdAt: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  devices: Array<AssignedDevices>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permission?: Maybe<UserAssetPermission>;
  successful?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type DeviceGroupActions = {
  __typename?: 'DeviceGroupActions';
  canAdd: Scalars['Boolean']['output'];
  mustSelectScope: Scalars['Boolean']['output'];
};

export type DeviceGroupSubscriptionInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  devices?: InputMaybe<Array<InputMaybe<AssignedDevicesInput>>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  subscriptionMode?: InputMaybe<SubscriptionMode>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceGroupUpdate = {
  __typename?: 'DeviceGroupUpdate';
  createdAt?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  devices?: Maybe<Array<Maybe<AssignedDevices>>>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subscriptionMode?: Maybe<SubscriptionMode>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type DeviceGroups = {
  __typename?: 'DeviceGroups';
  nodes: Array<DeviceGroup>;
  pageInfo: PaginationMetadata;
};

export type DeviceInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  currentCleaningReport?: InputMaybe<CleaningReportInput>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  firmwareDetail?: InputMaybe<DeviceFirmwareDetailInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastCleaningReport?: InputMaybe<CleaningReportInput>;
  lastOnline?: InputMaybe<Scalars['String']['input']>;
  materialNumber: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nextScheduledTask?: InputMaybe<NextCleaningScheduleInput>;
  producedRobotId?: InputMaybe<Scalars['String']['input']>;
  serialNumber: Scalars['String']['input'];
  settings?: InputMaybe<DeviceSettingsInput>;
  state?: InputMaybe<DeviceStateInput>;
  subscriptionMode?: InputMaybe<SubscriptionMode>;
  type?: InputMaybe<DeviceTypeName>;
  updateAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  wifiDetail?: InputMaybe<DeviceWifiNetworkDetailInput>;
};

export enum DeviceLanguage {
  Ar = 'ar',
  Bg = 'bg',
  Cs = 'cs',
  Da = 'da',
  De = 'de',
  El = 'el',
  En = 'en',
  Es = 'es',
  Et = 'et',
  Fi = 'fi',
  Fr = 'fr',
  Hr = 'hr',
  Hu = 'hu',
  It = 'it',
  Ja = 'ja',
  Ko = 'ko',
  Lv = 'lv',
  Nl = 'nl',
  No = 'no',
  Pl = 'pl',
  Pt = 'pt',
  Ro = 'ro',
  Ru = 'ru',
  Sk = 'sk',
  Sl = 'sl',
  Sr = 'sr',
  Sv = 'sv',
  Tr = 'tr',
  Uk = 'uk',
  Zh = 'zh'
}

export type DeviceLocation = {
  __typename?: 'DeviceLocation';
  coordinateT?: Maybe<Scalars['Float']['output']>;
  coordinateX: Scalars['Float']['output'];
  coordinateY: Scalars['Float']['output'];
  lastUpdated: Scalars['String']['output'];
  mapId?: Maybe<Scalars['String']['output']>;
};

export type DeviceLocationInput = {
  coordinateX?: InputMaybe<Scalars['Float']['input']>;
  coordinateY?: InputMaybe<Scalars['Float']['input']>;
  deviceId?: InputMaybe<Scalars['ID']['input']>;
  lastUpdated?: InputMaybe<Scalars['String']['input']>;
  mapId?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceLocationUpdate = {
  __typename?: 'DeviceLocationUpdate';
  coordinateX?: Maybe<Scalars['Float']['output']>;
  coordinateY?: Maybe<Scalars['Float']['output']>;
  deviceId?: Maybe<Scalars['ID']['output']>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  mapId?: Maybe<Scalars['String']['output']>;
  subscriptionMode?: Maybe<SubscriptionMode>;
};

export type DeviceMap = {
  __typename?: 'DeviceMap';
  nodes: Array<Map>;
};

export type DeviceMapLocation = {
  __typename?: 'DeviceMapLocation';
  coordinateT?: Maybe<Scalars['Float']['output']>;
  coordinateX: Scalars['Float']['output'];
  coordinateY: Scalars['Float']['output'];
  deviceId: Scalars['String']['output'];
  mapId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type DeviceMapLocationConnection = {
  __typename?: 'DeviceMapLocationConnection';
  history: Array<DeviceMapLocation>;
  latestLocation?: Maybe<DeviceMapLocation>;
  pageInfo: DeviceMapLocationPageInfo;
};

export type DeviceMapLocationPageInfo = {
  __typename?: 'DeviceMapLocationPageInfo';
  lastUpdatedAt: Scalars['String']['output'];
  limit: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type DeviceMapPositionInput = {
  coordinateT?: InputMaybe<Scalars['Float']['input']>;
  coordinateX?: InputMaybe<Scalars['Float']['input']>;
  coordinateY?: InputMaybe<Scalars['Float']['input']>;
  deviceId?: InputMaybe<Scalars['ID']['input']>;
  lastUpdated?: InputMaybe<Scalars['String']['input']>;
  mapId?: InputMaybe<Scalars['String']['input']>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceMapPositionUpdate = {
  __typename?: 'DeviceMapPositionUpdate';
  coordinateT?: Maybe<Scalars['Float']['output']>;
  coordinateX?: Maybe<Scalars['Float']['output']>;
  coordinateY?: Maybe<Scalars['Float']['output']>;
  deviceId?: Maybe<Scalars['ID']['output']>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  mapId?: Maybe<Scalars['String']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
};

export type DeviceMcuInfo = {
  __typename?: 'DeviceMcuInfo';
  machineState: DeviceStateEnum;
  mapCount: Scalars['Int']['output'];
  totalCleaningTime: Scalars['Int']['output'];
  totalOperation: Scalars['Int']['output'];
  usedStorage: Scalars['Int']['output'];
};

export type DeviceMcuInfoInput = {
  machineState?: InputMaybe<DeviceStateEnum>;
  mapCount?: InputMaybe<Scalars['Int']['input']>;
  totalCleaningTime?: InputMaybe<Scalars['Int']['input']>;
  totalOperation?: InputMaybe<Scalars['Int']['input']>;
  usedStorage?: InputMaybe<Scalars['Int']['input']>;
};

export type DeviceMcuInfoUpdate = {
  __typename?: 'DeviceMcuInfoUpdate';
  machineState?: Maybe<DeviceStateEnum>;
  mapCount?: Maybe<Scalars['Int']['output']>;
  totalCleaningTime?: Maybe<Scalars['Int']['output']>;
  totalOperation?: Maybe<Scalars['Int']['output']>;
  usedStorage?: Maybe<Scalars['Int']['output']>;
};

export type DeviceSettings = {
  __typename?: 'DeviceSettings';
  autoSideBroomSpeed?: Maybe<Scalars['Boolean']['output']>;
  autoUpdate?: Maybe<Scalars['Boolean']['output']>;
  batteryTheft: Scalars['Int']['output'];
  beep: Scalars['Int']['output'];
  blink: Scalars['Int']['output'];
  cableDetection?: Maybe<Scalars['Boolean']['output']>;
  carpetDetection?: Maybe<Scalars['Boolean']['output']>;
  cleaningMode?: Maybe<CleaningSuctionEnum>;
  customerId?: Maybe<Scalars['ID']['output']>;
  deviceId?: Maybe<Scalars['ID']['output']>;
  firmwareUpdatedAt: Scalars['String']['output'];
  firmwareVersion: Scalars['String']['output'];
  hmiLanguage: Scalars['String']['output'];
  lights: Scalars['Int']['output'];
  password?: Maybe<Scalars['String']['output']>;
  pinLock: Scalars['Int']['output'];
  quickCleaningMode?: Maybe<Scalars['Boolean']['output']>;
  soundOperating: Scalars['Int']['output'];
  soundVolume: Scalars['Int']['output'];
  soundWarning: Scalars['Int']['output'];
  ssid?: Maybe<Scalars['String']['output']>;
  theftProtection: Scalars['Int']['output'];
};

export type DeviceSettingsInput = {
  autoSideBroomSpeed?: InputMaybe<Scalars['Boolean']['input']>;
  autoUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  batteryTheft?: InputMaybe<Scalars['Int']['input']>;
  beep?: InputMaybe<Scalars['Int']['input']>;
  blink?: InputMaybe<Scalars['Int']['input']>;
  cableDetection?: InputMaybe<Scalars['Boolean']['input']>;
  carpetDetection?: InputMaybe<Scalars['Boolean']['input']>;
  cleaningMode?: InputMaybe<CleaningSuctionEnum>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  deviceId?: InputMaybe<Scalars['ID']['input']>;
  firmwareUpdatedAt?: InputMaybe<Scalars['String']['input']>;
  firmwareVersion?: InputMaybe<Scalars['String']['input']>;
  hmiLanguage?: InputMaybe<Scalars['String']['input']>;
  lights?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  pinLock?: InputMaybe<Scalars['Int']['input']>;
  quickCleaningMode?: InputMaybe<Scalars['Boolean']['input']>;
  soundOperating?: InputMaybe<Scalars['Int']['input']>;
  soundVolume?: InputMaybe<Scalars['Int']['input']>;
  soundWarning?: InputMaybe<Scalars['Int']['input']>;
  ssid?: InputMaybe<Scalars['String']['input']>;
  theftProtection?: InputMaybe<Scalars['Int']['input']>;
};

export type DeviceSettingsUpdate = {
  __typename?: 'DeviceSettingsUpdate';
  autoSideBroomSpeed?: Maybe<Scalars['Boolean']['output']>;
  autoUpdate?: Maybe<Scalars['Boolean']['output']>;
  batteryTheft?: Maybe<Scalars['Int']['output']>;
  beep?: Maybe<Scalars['Int']['output']>;
  blink?: Maybe<Scalars['Int']['output']>;
  cableDetection?: Maybe<Scalars['Boolean']['output']>;
  carpetDetection?: Maybe<Scalars['Boolean']['output']>;
  cleaningMode?: Maybe<CleaningSuctionEnum>;
  customerId?: Maybe<Scalars['ID']['output']>;
  deviceId?: Maybe<Scalars['ID']['output']>;
  firmwareUpdatedAt?: Maybe<Scalars['String']['output']>;
  firmwareVersion?: Maybe<Scalars['String']['output']>;
  hmiLanguage?: Maybe<Scalars['String']['output']>;
  lights?: Maybe<Scalars['Int']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  pinLock?: Maybe<Scalars['Int']['output']>;
  quickCleaningMode?: Maybe<Scalars['Boolean']['output']>;
  soundOperating?: Maybe<Scalars['Int']['output']>;
  soundVolume?: Maybe<Scalars['Int']['output']>;
  soundWarning?: Maybe<Scalars['Int']['output']>;
  ssid?: Maybe<Scalars['String']['output']>;
  theftProtection?: Maybe<Scalars['Int']['output']>;
};

export type DeviceState = {
  __typename?: 'DeviceState';
  availability: DeviceStateAvailabilityEnum;
  batteries: Array<BatteryPack>;
  batteryPack1: BatteryPack;
  batteryPack2: BatteryPack;
  batterySystemChargeLevel: Scalars['Float']['output'];
  cellularStatus: DeviceCellularStatus;
  charging: Scalars['Boolean']['output'];
  consumables: DeviceStateConsumables;
  deviceState: DeviceStateEnum;
  docked: Scalars['Boolean']['output'];
  location: DeviceLocation;
  mcuInfo: DeviceMcuInfo;
  paused: Scalars['Boolean']['output'];
  waterLevel: Scalars['Int']['output'];
  wifiStatus: DeviceWifiStatus;
};

export enum DeviceStateAvailabilityEnum {
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

export type DeviceStateConsumables = {
  __typename?: 'DeviceStateConsumables';
  brush?: Maybe<Scalars['Int']['output']>;
  dirtContainer?: Maybe<Scalars['Int']['output']>;
  filter?: Maybe<Scalars['Int']['output']>;
  rubberLip?: Maybe<Scalars['Int']['output']>;
  sensors?: Maybe<Scalars['Int']['output']>;
  sideBroom?: Maybe<Scalars['Int']['output']>;
};

export type DeviceStateConsumablesInput = {
  brush?: InputMaybe<Scalars['Int']['input']>;
  dirtContainer?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['Int']['input']>;
  rubberLip?: InputMaybe<Scalars['Int']['input']>;
  sensors?: InputMaybe<Scalars['Int']['input']>;
  sideBroom?: InputMaybe<Scalars['Int']['input']>;
};

export enum DeviceStateEnum {
  Boot = 'BOOT',
  Charging = 'CHARGING',
  Cleaning = 'CLEANING',
  CleaningMode = 'CLEANING_MODE',
  Docking = 'DOCKING',
  Driving = 'DRIVING',
  Error = 'ERROR',
  ErrorState = 'ERROR_STATE',
  Exploration = 'EXPLORATION',
  ExplorationMode = 'EXPLORATION_MODE',
  FlightMode = 'FLIGHT_MODE',
  Idle = 'IDLE',
  Localization = 'LOCALIZATION',
  Maintenance = 'MAINTENANCE',
  ManualCleaning = 'MANUAL_CLEANING',
  PathPlaning = 'PATH_PLANING',
  Pause = 'PAUSE',
  Sleep = 'SLEEP',
  Unknown = 'UNKNOWN',
  UpdateProcess = 'UPDATE_PROCESS',
  Waiting = 'WAITING',
  Warning = 'WARNING'
}

export type DeviceStateInput = {
  availability?: InputMaybe<DeviceStateAvailabilityEnum>;
  batteries?: InputMaybe<Array<InputMaybe<BatteryPackInput>>>;
  batteryPack1?: InputMaybe<BatteryPackInput>;
  batteryPack2?: InputMaybe<BatteryPackInput>;
  batterySystemChargeLevel?: InputMaybe<Scalars['Float']['input']>;
  cellularStatus?: InputMaybe<DeviceCellularStatusInput>;
  charging?: InputMaybe<Scalars['Boolean']['input']>;
  consumables?: InputMaybe<DeviceStateConsumablesInput>;
  deviceState?: InputMaybe<DeviceStateEnum>;
  docked?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<DeviceLocationInput>;
  mcuInfo?: InputMaybe<DeviceMcuInfoInput>;
  paused?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DeviceStateEnum>;
  waterLevel?: InputMaybe<Scalars['Int']['input']>;
  wifiStatus?: InputMaybe<DeviceWifiStatusInput>;
};

export type DeviceStateUpdate = {
  __typename?: 'DeviceStateUpdate';
  availability?: Maybe<DeviceStateAvailabilityEnum>;
  batteries?: Maybe<Array<Maybe<BatteryPackUpdate>>>;
  batteryPack1?: Maybe<BatteryPackUpdate>;
  batteryPack2?: Maybe<BatteryPackUpdate>;
  batterySystemChargeLevel?: Maybe<Scalars['Float']['output']>;
  cellularStatus?: Maybe<DeviceCellularStatusUpdate>;
  charging?: Maybe<Scalars['Boolean']['output']>;
  consumables?: Maybe<DeviceStateConsumables>;
  deviceState?: Maybe<DeviceStateEnum>;
  docked?: Maybe<Scalars['Boolean']['output']>;
  mcuInfo?: Maybe<DeviceMcuInfoUpdate>;
  paused?: Maybe<Scalars['Boolean']['output']>;
  waterLevel?: Maybe<Scalars['Int']['output']>;
  wifiStatus?: Maybe<DeviceWifiStatusUpdate>;
};

export enum DeviceTaskStatusEnum {
  Done = 'DONE',
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  Paused = 'PAUSED',
  Preparing = 'PREPARING'
}

export enum DeviceTaskTypeEnum {
  Cleaning = 'CLEANING',
  NewMap = 'NEW_MAP'
}

export enum DeviceTypeName {
  Cv50 = 'CV50',
  Cv50V2 = 'CV50_V2',
  KiraB50 = 'KIRA_B50',
  KiraBd20 = 'KIRA_BD20',
  KiraBd50 = 'KIRA_BD50',
  KiraBd200 = 'KIRA_BD200',
  KiraBr50 = 'KIRA_BR50',
  KiraBr200 = 'KIRA_BR200',
  Unknown = 'UNKNOWN'
}

export type DeviceUpdate = {
  __typename?: 'DeviceUpdate';
  createdAt?: Maybe<Scalars['String']['output']>;
  currentCleaningReport?: Maybe<CleaningReportUpdate>;
  customerId?: Maybe<Scalars['String']['output']>;
  firmwareDetail?: Maybe<DeviceFirmwareDetailUpdate>;
  id?: Maybe<Scalars['ID']['output']>;
  lastCleaningReport?: Maybe<CleaningReportUpdate>;
  lastOnline?: Maybe<Scalars['String']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nextScheduledTask?: Maybe<NextCleaningScheduleUpdate>;
  producedRobotId?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<DeviceSettingsUpdate>;
  state?: Maybe<DeviceStateUpdate>;
  subscriptionMode?: Maybe<SubscriptionMode>;
  type?: Maybe<DeviceTypeName>;
  updateAvailable?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  wifiDetail?: Maybe<DeviceWifiNetworkDetailUpdate>;
};

export type DeviceWifiNetworkDetail = {
  __typename?: 'DeviceWifiNetworkDetail';
  ipv4Address: Scalars['String']['output'];
  ipv6Address: Scalars['String']['output'];
  macAddress: Scalars['String']['output'];
  networkName: Scalars['String']['output'];
  signalStrength: Scalars['Int']['output'];
  subnetMask: Scalars['String']['output'];
};

export type DeviceWifiNetworkDetailInput = {
  ipv4Address?: InputMaybe<Scalars['String']['input']>;
  ipv6Address?: InputMaybe<Scalars['String']['input']>;
  macAddress?: InputMaybe<Scalars['String']['input']>;
  networkName?: InputMaybe<Scalars['String']['input']>;
  signalStrength?: InputMaybe<Scalars['Int']['input']>;
  subnetMask?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceWifiNetworkDetailUpdate = {
  __typename?: 'DeviceWifiNetworkDetailUpdate';
  ipv4Address?: Maybe<Scalars['String']['output']>;
  ipv6Address?: Maybe<Scalars['String']['output']>;
  macAddress?: Maybe<Scalars['String']['output']>;
  networkName?: Maybe<Scalars['String']['output']>;
  signalStrength?: Maybe<Scalars['Int']['output']>;
  subnetMask?: Maybe<Scalars['String']['output']>;
};

export type DeviceWifiStatus = {
  __typename?: 'DeviceWifiStatus';
  defaultGateway: Scalars['String']['output'];
  ipv4Address: Scalars['String']['output'];
  ipv6Address: Scalars['String']['output'];
  macAddress: Scalars['String']['output'];
  networkName: Scalars['String']['output'];
  signalStrength: Scalars['Int']['output'];
  subnetMask: Scalars['Int']['output'];
};

export type DeviceWifiStatusInput = {
  defaultGateway?: InputMaybe<Scalars['String']['input']>;
  ipv4Address?: InputMaybe<Scalars['String']['input']>;
  ipv6Address?: InputMaybe<Scalars['String']['input']>;
  macAddress?: InputMaybe<Scalars['String']['input']>;
  networkName?: InputMaybe<Scalars['String']['input']>;
  signalStrength?: InputMaybe<Scalars['Int']['input']>;
  subnetMask?: InputMaybe<Scalars['Int']['input']>;
};

export type DeviceWifiStatusUpdate = {
  __typename?: 'DeviceWifiStatusUpdate';
  defaultGateway?: Maybe<Scalars['String']['output']>;
  ipv4Address?: Maybe<Scalars['String']['output']>;
  ipv6Address?: Maybe<Scalars['String']['output']>;
  macAddress?: Maybe<Scalars['String']['output']>;
  networkName?: Maybe<Scalars['String']['output']>;
  signalStrength?: Maybe<Scalars['Int']['output']>;
  subnetMask?: Maybe<Scalars['Int']['output']>;
};

export type DiscoveredWifis = {
  __typename?: 'DiscoveredWifis';
  mac: Scalars['String']['output'];
  ss: Scalars['Int']['output'];
  ssid: Scalars['String']['output'];
};

export type EditMapGroupInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type FilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};

export type FirmwareRelease = {
  __typename?: 'FirmwareRelease';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isTest?: Maybe<Scalars['Boolean']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  releasedAt?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type FirmwareReleases = {
  __typename?: 'FirmwareReleases';
  nodes: Array<FirmwareRelease>;
};

export type FirmwareUpdate = {
  __typename?: 'FirmwareUpdate';
  detail?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  failureCause?: Maybe<Scalars['String']['output']>;
  firmwareReleaseId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  materialNumber?: Maybe<Scalars['String']['output']>;
  needApproval?: Maybe<Scalars['Boolean']['output']>;
  progress?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type FirmwareUpdateResponse = {
  __typename?: 'FirmwareUpdateResponse';
  nodes?: Maybe<Array<Maybe<FirmwareUpdate>>>;
};

export type FirmwareUpdateSubscription = {
  __typename?: 'FirmwareUpdateSubscription';
  deviceId?: Maybe<Scalars['String']['output']>;
  firmwareReleaseId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subscriptionMode?: Maybe<SubscriptionMode>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type FirmwareUpdateSubscriptionInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  firmwareReleaseId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subscriptionMode?: InputMaybe<SubscriptionMode>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type GeneralCleaningCommandInput = {
  materialNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export type GeneralCommandResponse = {
  __typename?: 'GeneralCommandResponse';
  successful: Scalars['Boolean']['output'];
};

export type InvitationInfo = {
  __typename?: 'InvitationInfo';
  companyName: Scalars['String']['output'];
  invitationCode: Scalars['String']['output'];
  inviterName: Scalars['String']['output'];
};

export type LocationActions = {
  __typename?: 'LocationActions';
  canCreate: Scalars['Boolean']['output'];
  canView: Scalars['Boolean']['output'];
};

export type MnsNsInput = {
  materialNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export type Map = {
  __typename?: 'Map';
  active?: Maybe<Scalars['Boolean']['output']>;
  associatedDevices: Array<Maybe<AssociatedDevices>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  creationMode?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['String']['output'];
  deviceId: Scalars['String']['output'];
  deviceType?: Maybe<Scalars['String']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  fullPreview?: Maybe<Scalars['String']['output']>;
  function?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isNewMap?: Maybe<Scalars['Boolean']['output']>;
  jsonData?: Maybe<PraMapJsonData>;
  lastUpdatedAt?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  mapGroupName?: Maybe<Scalars['String']['output']>;
  materialNumber: Scalars['String']['output'];
  name: Scalars['String']['output'];
  permission?: Maybe<UserAssetPermission>;
  preview?: Maybe<Scalars['String']['output']>;
  serialNumber: Scalars['String']['output'];
  status?: Maybe<MapStatusEnum>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
  work?: Maybe<Scalars['String']['output']>;
};

export type MapActions = {
  __typename?: 'MapActions';
  canAdd: Scalars['Boolean']['output'];
};

export type MapEditor = {
  configContent?: InputMaybe<Scalars['String']['input']>;
  eraseContent?: InputMaybe<Scalars['String']['input']>;
  functionContent?: InputMaybe<Scalars['String']['input']>;
  mapId: Scalars['ID']['input'];
  revertEraseContent?: InputMaybe<Scalars['String']['input']>;
  workContent?: InputMaybe<Scalars['String']['input']>;
};

export type MapGroup = {
  __typename?: 'MapGroup';
  assignedMaps: Array<AssignedMaps>;
  id: Scalars['ID']['output'];
  mapGroupCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  permission?: Maybe<UserAssetPermission>;
};

export type MapGroupActions = {
  __typename?: 'MapGroupActions';
  canAdd: Scalars['Boolean']['output'];
  mustSelectScope: Scalars['Boolean']['output'];
};

export type MapGroupEdit = {
  __typename?: 'MapGroupEdit';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MapGroups = {
  __typename?: 'MapGroups';
  nodes: Array<MapGroup>;
  pageInfo: PaginationMetadata;
};

export enum MapStatusEnum {
  Active = 'ACTIVE',
  Created = 'CREATED',
  Deleted = 'DELETED',
  Exploration = 'EXPLORATION',
  NewMap = 'NEW_MAP',
  Requested = 'REQUESTED'
}

export type Maps = {
  __typename?: 'Maps';
  nodes: Array<Map>;
  pageInfo: PaginationMetadata;
};

export type Membership = {
  __typename?: 'Membership';
  role: UserRole;
  scope: ScopeSummary;
};

export type MembershipInput = {
  roleId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvitation: AcceptCustomerInvitation;
  addDevicesToGroup: DeviceGroup;
  assignDeviceGroupsToScope: ScopesMutationResponse;
  assignMapGroupsToScope: ScopesMutationResponse;
  assignUsersToScope: ScopesMutationResponse;
  associateDevicesToMap: AssociateDevicesToMapResponse;
  associateMapsToGroup: AssociateMapsToGroupResponse;
  cancelInvitation: CustomerInvitation;
  changeBluetoothConnectivity: GeneralCommandResponse;
  changeDeviceLanguage: ChangeDeviceLanguage;
  changeDeviceName: ChangeDeviceName;
  changeDevicePin: ChangeDevicePin;
  changeDeviceSound: ChangeDeviceSound;
  changeFirmwareUpdateMode: ChangeFirmwareUpdateMode;
  changePassword: ChangePasswordResponse;
  claimDevice: ClaimedDevice;
  claimedDevice: ClaimDeviceSubscription;
  cleaningSchedule: CleaningScheduleUpdate;
  cleaningTask: RobotTaskUpdate;
  cleaningTaskProgress: RobotTaskProgressUpdate;
  cloneMap: CloneMapResponse;
  commandSend: CommandStatus;
  continueCleaning: GeneralCommandResponse;
  createCustomRole: CustomRole;
  createDeviceGroup: DeviceGroup;
  createInvitation: CustomerInvitation;
  createMapGroup: MapGroupEdit;
  createSchedule: CleaningScheduleV2;
  createScope: ScopeMutationResponse;
  deleteCustomRole: SuccessfulResponse;
  deleteDeviceGroup: SuccessfulResponse;
  deleteMap: DeleteMapResponse;
  deleteMapGroup: DeleteMapGroupResponse;
  deleteSchedule: CleaningScheduleV2;
  deleteScope: SuccessfulResponse;
  device?: Maybe<DeviceUpdate>;
  deviceFirmwareUpdate: DeviceFirmwareUpdateSubscription;
  deviceGroups: DeviceGroupUpdate;
  deviceLocation: DeviceLocationUpdate;
  deviceMapPosition: DeviceMapPositionUpdate;
  editMapGroup: MapGroupEdit;
  firmwareUpdate: FirmwareUpdateSubscription;
  mapEditor: Map;
  mapGroups: PraSubMapGroups;
  maps: PraSubMaps;
  notification: NotificationUpdate;
  notificationRead: Notification;
  notificationReadAll: NotificationReadAllResponse;
  pauseCleaning: GeneralCommandResponse;
  permissionUpdate?: Maybe<PermissionUpdate>;
  publishScheduleChanged: CleaningScheduleV2;
  registerUser: RegisterUserResponse;
  removeCustomerUser: RemoveCustomerUser;
  removeDevice: RemoveDevice;
  removeDevicesFromGroup: DeviceGroup;
  restartFirmwareUpdate?: Maybe<RestartFirmwareUpdate>;
  sendBRangeCleaningCommand: GeneralCommandResponse;
  sendSupportRequest: SupportRequestResponse;
  setScheduleActive: CleaningScheduleV2;
  setScopeName: ScopeMutationResponse;
  setUserSubscriptions: PushNotificationMutationResponse;
  startCleaning: GeneralCommandResponse;
  startFirmwareUpdate?: Maybe<StartFirmwareUpdate>;
  startRemoteExploration: GeneralCommandResponse;
  stopCleaning: GeneralCommandResponse;
  unassociateDevicesToMap: UnassociateDevicesToMapResponse;
  unassociateMapsToGroup: UnassociateMapsToGroupResponse;
  unclaimDevice: UnclaimedDevice;
  unclaimedDevice: UnclaimDeviceSubscription;
  updateCustomRole: CustomRole;
  updateDeviceGroup: DeviceGroup;
  updateMap: Map;
  updateRolePermissions?: Maybe<Role>;
  updateSchedule: CleaningScheduleV2;
  user?: Maybe<UserUpdate>;
  userNotificationUpdate: UserNotification;
  validateInvitation: ValidateCustomerInvitation;
};


export type MutationAcceptInvitationArgs = {
  input: AcceptInvitationInput;
};


export type MutationAddDevicesToGroupArgs = {
  input: AddDevicesToGroupInput;
};


export type MutationAssignDeviceGroupsToScopeArgs = {
  input: AssignDeviceGroupsToScopeInput;
};


export type MutationAssignMapGroupsToScopeArgs = {
  input: AssignMapGroupsToScopeInput;
};


export type MutationAssignUsersToScopeArgs = {
  input: AssignUsersToScopeInput;
};


export type MutationAssociateDevicesToMapArgs = {
  input: AssociateDevicesToMapInput;
};


export type MutationAssociateMapsToGroupArgs = {
  input: AssociateMapsToGroupInput;
};


export type MutationCancelInvitationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChangeBluetoothConnectivityArgs = {
  input: ChangeBluetoothConnectivityInput;
};


export type MutationChangeDeviceLanguageArgs = {
  input: ChangeDeviceLanguageInput;
};


export type MutationChangeDeviceNameArgs = {
  input: ChangeDeviceNameInput;
};


export type MutationChangeDevicePinArgs = {
  input: ChangeDevicePinInput;
};


export type MutationChangeDeviceSoundArgs = {
  input: ChangeDeviceSoundInput;
};


export type MutationChangeFirmwareUpdateModeArgs = {
  input: ChangeFirmwareUpdateModeInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationClaimDeviceArgs = {
  input: ClaimDeviceInput;
};


export type MutationClaimedDeviceArgs = {
  input: ClaimDeviceSubscriptionInput;
};


export type MutationCleaningScheduleArgs = {
  input: CleaningScheduleInput;
};


export type MutationCleaningTaskArgs = {
  input: RobotTaskSubscriptionInput;
};


export type MutationCleaningTaskProgressArgs = {
  input: RobotTaskProgressSubscriptionInput;
};


export type MutationCloneMapArgs = {
  input: CloneMapInput;
};


export type MutationCommandSendArgs = {
  input: CommandSendInput;
};


export type MutationContinueCleaningArgs = {
  input: GeneralCleaningCommandInput;
};


export type MutationCreateCustomRoleArgs = {
  input: CreateCustomRoleInput;
};


export type MutationCreateDeviceGroupArgs = {
  input: CreateDeviceGroupInput;
};


export type MutationCreateInvitationArgs = {
  input: CreateInvitationInput;
};


export type MutationCreateMapGroupArgs = {
  input: CreateMapGroupInput;
};


export type MutationCreateScheduleArgs = {
  input: CreateScheduleInput;
};


export type MutationCreateScopeArgs = {
  input: CreateScopeInput;
};


export type MutationDeleteCustomRoleArgs = {
  input: DeleteCustomRoleInput;
};


export type MutationDeleteDeviceGroupArgs = {
  input: DeleteDeviceGroupInput;
};


export type MutationDeleteMapArgs = {
  input: DeleteMapInput;
};


export type MutationDeleteMapGroupArgs = {
  input: DeleteMapGroupInput;
};


export type MutationDeleteScheduleArgs = {
  input: DeleteScheduleInput;
};


export type MutationDeleteScopeArgs = {
  input: DeleteScopeInput;
};


export type MutationDeviceArgs = {
  input: DeviceInput;
};


export type MutationDeviceFirmwareUpdateArgs = {
  input: DeviceFirmwareUpdateSubscriptionInput;
};


export type MutationDeviceGroupsArgs = {
  input: DeviceGroupSubscriptionInput;
};


export type MutationDeviceLocationArgs = {
  input: DeviceLocationInput;
};


export type MutationDeviceMapPositionArgs = {
  input: DeviceMapPositionInput;
};


export type MutationEditMapGroupArgs = {
  input: EditMapGroupInput;
};


export type MutationFirmwareUpdateArgs = {
  input: FirmwareUpdateSubscriptionInput;
};


export type MutationMapEditorArgs = {
  input: MapEditor;
};


export type MutationMapGroupsArgs = {
  input: PraSubMapGroupInput;
};


export type MutationMapsArgs = {
  input: PraSubMapInput;
};


export type MutationNotificationArgs = {
  input: NotificationInput;
};


export type MutationNotificationReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPauseCleaningArgs = {
  input: GeneralCleaningCommandInput;
};


export type MutationPermissionUpdateArgs = {
  input: PermissionUpdateInput;
};


export type MutationPublishScheduleChangedArgs = {
  input: CleaningScheduleV2Input;
};


export type MutationRegisterUserArgs = {
  input: RegisterUserInput;
};


export type MutationRemoveCustomerUserArgs = {
  input: RemoveCustomerUserInput;
};


export type MutationRemoveDeviceArgs = {
  input: RemoveDeviceInput;
};


export type MutationRemoveDevicesFromGroupArgs = {
  input: RemoveDevicesFromGroupInput;
};


export type MutationRestartFirmwareUpdateArgs = {
  input: RestartFirmwareUpdateInput;
};


export type MutationSendBRangeCleaningCommandArgs = {
  input: BRangeCleaningCommandInput;
};


export type MutationSendSupportRequestArgs = {
  input: SupportRequestInput;
};


export type MutationSetScheduleActiveArgs = {
  input: SetScheduleActiveInput;
};


export type MutationSetScopeNameArgs = {
  input: SetScopeNameInput;
};


export type MutationSetUserSubscriptionsArgs = {
  input: SubscriptionInput;
};


export type MutationStartCleaningArgs = {
  input: StartCleaningCommandInput;
};


export type MutationStartFirmwareUpdateArgs = {
  input: StartFirmwareUpdateInput;
};


export type MutationStartRemoteExplorationArgs = {
  input: GeneralCleaningCommandInput;
};


export type MutationStopCleaningArgs = {
  input: StopCleaningCommandInput;
};


export type MutationUnassociateDevicesToMapArgs = {
  input: UnassociateDevicesToMapInput;
};


export type MutationUnassociateMapsToGroupArgs = {
  input: UnassociateMapsToGroupInput;
};


export type MutationUnclaimDeviceArgs = {
  input: UnclaimDeviceInput;
};


export type MutationUnclaimedDeviceArgs = {
  input: UnclaimDeviceSubscriptionInput;
};


export type MutationUpdateCustomRoleArgs = {
  input: UpdateCustomRoleInput;
};


export type MutationUpdateDeviceGroupArgs = {
  input: UpdateDeviceGroupInput;
};


export type MutationUpdateMapArgs = {
  input: UpdateMapInput;
};


export type MutationUpdateRolePermissionsArgs = {
  input: UpdateRolePermissionsInput;
};


export type MutationUpdateScheduleArgs = {
  input: UpdateScheduleInput;
};


export type MutationUserArgs = {
  input: UserInput;
};


export type MutationUserNotificationUpdateArgs = {
  input: UserNotificationUpdateInput;
};


export type MutationValidateInvitationArgs = {
  input: ValidateInvitationInput;
};

export type NetworkInfo = {
  __typename?: 'NetworkInfo';
  discoveredWifis: Array<DiscoveredWifis>;
  savedWifis: Array<SavedWifis>;
  updatedAt: Scalars['String']['output'];
};

export type NextCleaningSchedule = {
  __typename?: 'NextCleaningSchedule';
  areaInSquareMeters: Scalars['Int']['output'];
  cleaningDurationInSeconds: Scalars['Int']['output'];
  cleaningZones?: Maybe<Array<Scalars['String']['output']>>;
  deviceId: Scalars['String']['output'];
  deviceName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mapId: Scalars['String']['output'];
  mapName: Scalars['String']['output'];
  nextExecution: Scalars['String']['output'];
  repetition: CleaningScheduleRepetitionEnum;
  startTime: Scalars['String']['output'];
  suction: CleaningSuctionEnum;
  weekdays: Array<Scalars['Int']['output']>;
};

export type NextCleaningScheduleInput = {
  areaInSquareMeters?: InputMaybe<Scalars['Int']['input']>;
  cleaningDurationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  cleaningZones?: InputMaybe<Array<Scalars['String']['input']>>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  mapId?: InputMaybe<Scalars['String']['input']>;
  mapName?: InputMaybe<Scalars['String']['input']>;
  nextExecution?: InputMaybe<Scalars['String']['input']>;
  repetition?: InputMaybe<CleaningScheduleRepetitionEnum>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  suction?: InputMaybe<CleaningSuctionEnum>;
  weekdays?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NextCleaningScheduleUpdate = {
  __typename?: 'NextCleaningScheduleUpdate';
  areaInSquareMeters?: Maybe<Scalars['Int']['output']>;
  cleaningDurationInSeconds?: Maybe<Scalars['Int']['output']>;
  cleaningZones?: Maybe<Array<Scalars['String']['output']>>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  mapId?: Maybe<Scalars['String']['output']>;
  mapName?: Maybe<Scalars['String']['output']>;
  nextExecution?: Maybe<Scalars['String']['output']>;
  repetition?: Maybe<CleaningScheduleRepetitionEnum>;
  startTime?: Maybe<Scalars['String']['output']>;
  suction?: Maybe<CleaningSuctionEnum>;
  weekdays?: Maybe<Array<Scalars['Int']['output']>>;
};

export type Notification = {
  __typename?: 'Notification';
  active: Scalars['Int']['output'];
  category: NotificationCategoryTypeEnum;
  code: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  details?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  materialNumber?: Maybe<Scalars['String']['output']>;
  notificationType: NotificationTypeEnum;
  serialNumber?: Maybe<Scalars['String']['output']>;
  severity: NotificationSeverityEnum;
  unread: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum NotificationCategoryTypeEnum {
  CleaningTaskFinished = 'CLEANING_TASK_FINISHED',
  CleaningTaskInterrupted = 'CLEANING_TASK_INTERRUPTED',
  EmergencyStop = 'EMERGENCY_STOP',
  ErrorOccurred = 'ERROR_OCCURRED',
  Information = 'INFORMATION',
  InternalEvent = 'INTERNAL_EVENT',
  NotAssigned = 'NOT_ASSIGNED',
  NoWorkStart = 'NO_WORK_START',
  Resources = 'RESOURCES'
}

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  nodes: Array<Notification>;
  pageInfo: NotificationPaginationMetadata;
};

export type NotificationConnectionWithoutPaginationSettings = {
  __typename?: 'NotificationConnectionWithoutPaginationSettings';
  nodes: Array<Notification>;
};

export type NotificationInput = {
  active?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<NotificationCategoryTypeEnum>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  details?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  notificationType?: InputMaybe<NotificationTypeEnum>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<NotificationSeverityEnum>;
  subscriptionMode?: InputMaybe<SubscriptionMode>;
  unread?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationPaginationMetadata = {
  __typename?: 'NotificationPaginationMetadata';
  lastTimestamp: Scalars['String']['output'];
  limit: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type NotificationReadAllResponse = {
  __typename?: 'NotificationReadAllResponse';
  successful: Scalars['Boolean']['output'];
};

export enum NotificationSeverityEnum {
  Critical = 'CRITICAL',
  Info = 'INFO',
  Major = 'MAJOR',
  Minor = 'MINOR'
}

export enum NotificationStateEnum {
  Read = 'READ',
  Unread = 'UNREAD'
}

export enum NotificationTypeEnum {
  Device = 'DEVICE',
  User = 'USER'
}

export type NotificationUpdate = {
  __typename?: 'NotificationUpdate';
  active?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<NotificationCategoryTypeEnum>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  notificationType?: Maybe<NotificationTypeEnum>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<NotificationSeverityEnum>;
  subscriptionMode?: Maybe<SubscriptionMode>;
  unread?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type PaginationMetadata = {
  __typename?: 'PaginationMetadata';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  order: Scalars['String']['output'];
  orderBy: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type PeriodInput = {
  endAt: Scalars['String']['input'];
  startAt: Scalars['String']['input'];
};

export enum PermissionEventType {
  MembershipAssigned = 'MEMBERSHIP_ASSIGNED',
  MembershipRemoved = 'MEMBERSHIP_REMOVED',
  RoleDeleted = 'ROLE_DELETED',
  RolePermissionsUpdated = 'ROLE_PERMISSIONS_UPDATED',
  ScopeAssetsUpdated = 'SCOPE_ASSETS_UPDATED',
  ScopeDeleted = 'SCOPE_DELETED'
}

export type PermissionUpdate = {
  __typename?: 'PermissionUpdate';
  customerId: Scalars['String']['output'];
  eventType?: Maybe<PermissionEventType>;
  subscriptionMode?: Maybe<SubscriptionMode>;
  userId: Scalars['ID']['output'];
};

export type PermissionUpdateInput = {
  customerId: Scalars['String']['input'];
  eventType: PermissionEventType;
  subscriptionMode?: InputMaybe<SubscriptionMode>;
  userId: Scalars['ID']['input'];
};

export type Permissions = {
  __typename?: 'Permissions';
  device: AssetPermissionEnum;
  deviceGroup: AssetPermissionEnum;
  map: AssetPermissionEnum;
  mapGroup: AssetPermissionEnum;
  user: AssetPermissionEnum;
};

export type PraMapContent = {
  __typename?: 'PraMapContent';
  config?: Maybe<Scalars['String']['output']>;
  function?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  mapInfo?: Maybe<Scalars['String']['output']>;
  work?: Maybe<Scalars['String']['output']>;
};

export type PraMapContentInput = {
  config?: InputMaybe<Scalars['String']['input']>;
  function?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  mapInfo?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<Scalars['String']['input']>;
};

export type PraMapJsonData = {
  __typename?: 'PraMapJsonData';
  date?: Maybe<Scalars['String']['output']>;
  jsonContent?: Maybe<PraMapContent>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type PraMapJsonDataInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  jsonContent?: InputMaybe<PraMapContentInput>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type PraSubMapGroupInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  mode?: InputMaybe<SubscriptionMode>;
  name?: InputMaybe<Scalars['String']['input']>;
  subscriptionMode?: InputMaybe<SubscriptionMode>;
};

export type PraSubMapGroups = {
  __typename?: 'PraSubMapGroups';
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  mode?: Maybe<SubscriptionMode>;
  name?: Maybe<Scalars['String']['output']>;
  subscriptionMode?: Maybe<SubscriptionMode>;
};

export type PraSubMapInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  associatedDeviceMaterialNumber?: InputMaybe<Scalars['String']['input']>;
  associatedDeviceSerialNumber?: InputMaybe<Scalars['String']['input']>;
  associatedDevices?: InputMaybe<Array<InputMaybe<AssociatedDevicesInput>>>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  creationMode?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  deviceId?: InputMaybe<Scalars['String']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  fullPreview?: InputMaybe<Scalars['String']['input']>;
  function?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  isNewMap?: InputMaybe<Scalars['Boolean']['input']>;
  jsonData?: InputMaybe<PraMapJsonDataInput>;
  lastUpdatedAt?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  mapGroupName?: InputMaybe<Scalars['String']['input']>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<SubscriptionMode>;
  name?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MapStatusEnum>;
  subscriptionMode?: InputMaybe<SubscriptionMode>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
  work?: InputMaybe<Scalars['String']['input']>;
};

export type PraSubMaps = {
  __typename?: 'PraSubMaps';
  active?: Maybe<Scalars['Boolean']['output']>;
  associatedDeviceMaterialNumber?: Maybe<Scalars['String']['output']>;
  associatedDeviceSerialNumber?: Maybe<Scalars['String']['output']>;
  associatedDevices?: Maybe<Array<Maybe<AssociatedDevices>>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  creationMode?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  fullPreview?: Maybe<Scalars['String']['output']>;
  function?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  isNewMap?: Maybe<Scalars['Boolean']['output']>;
  jsonData?: Maybe<PraMapJsonData>;
  lastUpdatedAt?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  mapGroupName?: Maybe<Scalars['String']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<SubscriptionMode>;
  name?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<MapStatusEnum>;
  subscriptionMode?: Maybe<SubscriptionMode>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
  work?: Maybe<Scalars['String']['output']>;
};

export type PushNotificationMutationResponse = {
  __typename?: 'PushNotificationMutationResponse';
  successful: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  cleaningReport: CleaningReport;
  cleaningReportMap?: Maybe<CleaningReportMap>;
  cleaningReports: AllCleaningReports;
  cleaningSchedule: CleaningSchedule;
  cleaningScheduleOccurrences: Array<CleaningScheduleOccurrence>;
  cleaningSchedules: CleaningScheduleConnection;
  cleaningTask: RobotTask;
  cleaningTasks: RobotTasks;
  commandStatus: CommandStatus;
  customer: Customer;
  device: Device;
  deviceFirmwareUpdate: FirmwareUpdate;
  deviceFirmwareUpdates: Array<FirmwareUpdate>;
  deviceGroup: DeviceGroup;
  deviceGroups: DeviceGroups;
  deviceMapLocation: DeviceMapLocationConnection;
  devices: DeviceConnection;
  firmwareReleases: FirmwareReleases;
  firmwareUpdate: FirmwareUpdateResponse;
  invitation: CustomerInvitation;
  invitationInfo: InvitationInfo;
  invitations: ConnectedCustomerInvitation;
  map: Map;
  mapGroups: MapGroups;
  maps: Maps;
  networkInfo: NetworkInfo;
  notification: Notification;
  notifications: NotificationConnection;
  role: Role;
  roles: Roles;
  route: Route;
  routes: RouteConnection;
  routine: Routine;
  routines: RoutineConnection;
  schedule: CleaningScheduleV2;
  schedules: CleaningScheduleV2Connection;
  scope: ScopeDetail;
  scopes: Scopes;
  user: User;
  userCustomer: UserCustomer;
  userInfo?: Maybe<UserInfo>;
  userSubscriptions: CategorySubscriptionsQueryResponse;
  validateClaiming: ValidatedClaiming;
};


export type QueryCleaningReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCleaningReportMapArgs = {
  id: Scalars['ID']['input'];
  materialNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};


export type QueryCleaningReportsArgs = {
  activities?: InputMaybe<Array<CleaningActivityEnum>>;
  activity?: InputMaybe<CleaningActivityEnum>;
  cleaningGroupId?: InputMaybe<Scalars['String']['input']>;
  cleaningGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  deviceType?: InputMaybe<DeviceTypeName>;
  deviceTypes?: InputMaybe<Array<DeviceTypeName>>;
  filter?: InputMaybe<FilterInput>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  mapId?: InputMaybe<Scalars['String']['input']>;
  mapIds?: InputMaybe<Array<Scalars['String']['input']>>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  materialNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  reportType?: InputMaybe<Array<InputMaybe<CleaningReportTypeEnum>>>;
  routineId?: InputMaybe<Scalars['String']['input']>;
  routineIds?: InputMaybe<Array<Scalars['String']['input']>>;
  scopes?: InputMaybe<Array<CleaningScopeEnum>>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  serialNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<CleaningStatusEnum>;
  statuses?: InputMaybe<Array<CleaningStatusEnum>>;
  time?: InputMaybe<CleaningReportTimeFilter>;
};


export type QueryCleaningScheduleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCleaningScheduleOccurrencesArgs = {
  materialNumber: Scalars['String']['input'];
  period: PeriodInput;
  serialNumber: Scalars['String']['input'];
};


export type QueryCleaningTaskArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  materialNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};


export type QueryCleaningTasksArgs = {
  filter?: InputMaybe<FilterInput>;
  materialNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};


export type QueryCommandStatusArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDeviceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDeviceFirmwareUpdateArgs = {
  materialNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};


export type QueryDeviceFirmwareUpdatesArgs = {
  materialNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};


export type QueryDeviceGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDeviceGroupsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryDeviceMapLocationArgs = {
  deviceId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<TimestampFilterInput>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDevicesArgs = {
  availabilities?: InputMaybe<Array<InputMaybe<DeviceStateAvailabilityEnum>>>;
  dateOfClaim?: InputMaybe<Scalars['String']['input']>;
  deviceStates?: InputMaybe<Array<InputMaybe<DeviceStateEnum>>>;
  deviceTypes?: InputMaybe<Array<InputMaybe<DeviceTypeName>>>;
  filter?: InputMaybe<FilterInput>;
  lastOnline?: InputMaybe<Scalars['String']['input']>;
  materialNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  serialNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFirmwareReleasesArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterInput>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFirmwareUpdateArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInvitationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvitationInfoArgs = {
  invitationCode: Scalars['String']['input'];
};


export type QueryInvitationsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMapArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMapGroupsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryMapsArgs = {
  deviceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  filter?: InputMaybe<FilterInput>;
  groupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  mnsns?: InputMaybe<Array<MnsNsInput>>;
};


export type QueryNetworkInfoArgs = {
  deviceInput: UniqueDeviceInput;
};


export type QueryNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotificationsArgs = {
  categories?: InputMaybe<Array<NotificationCategoryTypeEnum>>;
  codes?: InputMaybe<Array<Scalars['String']['input']>>;
  deviceId?: InputMaybe<Scalars['ID']['input']>;
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  deviceType?: InputMaybe<DeviceTypeName>;
  deviceTypes?: InputMaybe<Array<DeviceTypeName>>;
  filter?: InputMaybe<TimestampFilterInput>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  materialNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notificationTypes?: InputMaybe<Array<NotificationTypeEnum>>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  serialNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  severities?: InputMaybe<Array<NotificationSeverityEnum>>;
  states?: InputMaybe<Array<NotificationStateEnum>>;
};


export type QueryRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRolesArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRouteArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  robotRouteKey?: InputMaybe<RobotRouteKeyInput>;
};


export type QueryRoutesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  deviceTypes?: InputMaybe<Array<DeviceTypeName>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<RouteOrder>;
  robotRouteId?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRoutineArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  robotRoutineKey?: InputMaybe<RobotRoutineKeyInput>;
};


export type QueryRoutinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  deviceTypes?: InputMaybe<Array<DeviceTypeName>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<RoutineOrder>;
  robotRoutineId?: InputMaybe<Scalars['String']['input']>;
  routeId?: InputMaybe<Scalars['Int']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScheduleArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  excludeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  mapId?: InputMaybe<Scalars['String']['input']>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<CleaningScheduleV2Order>;
  repeatId?: InputMaybe<Scalars['String']['input']>;
  routineId?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ScheduleType>;
};


export type QueryScopeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserSubscriptionsArgs = {
  deviceToken: Scalars['String']['input'];
};


export type QueryValidateClaimingArgs = {
  materialNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export type RegisterUserInput = {
  academicTitle: Scalars['String']['input'];
  companyOnboarding: CompanyOnboardingInput;
  country: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  firstName2?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  lastName2?: InputMaybe<Scalars['String']['input']>;
  mobileNumber: Scalars['String']['input'];
  mobileNumberCountry: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  phoneNumberCountry: Scalars['String']['input'];
  preferredLanguage: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type RegisterUserResponse = {
  __typename?: 'RegisterUserResponse';
  successful: Scalars['Boolean']['output'];
};

export type RemoveCustomerUser = {
  __typename?: 'RemoveCustomerUser';
  successful: Scalars['Boolean']['output'];
};

export type RemoveCustomerUserInput = {
  email: Scalars['String']['input'];
};

export type RemoveDevice = {
  __typename?: 'RemoveDevice';
  successful: Scalars['Boolean']['output'];
};

export type RemoveDeviceInput = {
  materialNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export type RemoveDevicesFromGroupInput = {
  deviceIds: Array<Scalars['ID']['input']>;
  groupId: Scalars['ID']['input'];
};

export type RestartFirmwareUpdate = {
  __typename?: 'RestartFirmwareUpdate';
  successful?: Maybe<Scalars['Boolean']['output']>;
};

export type RestartFirmwareUpdateInput = {
  id: Scalars['String']['input'];
};

export type RobotRouteKeyInput = {
  materialNumber: Scalars['String']['input'];
  robotRouteId: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export type RobotRoutineKeyInput = {
  materialNumber: Scalars['String']['input'];
  robotRoutineId: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export type RobotTask = {
  __typename?: 'RobotTask';
  createdAt: Scalars['String']['output'];
  estimatedEndTime?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mapId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<RobotTaskProgress>;
  remainingTime?: Maybe<Scalars['Int']['output']>;
  startTime: Scalars['String']['output'];
  status: DeviceTaskStatusEnum;
  subName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type RobotTaskProgress = {
  __typename?: 'RobotTaskProgress';
  cleanedArea?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  progress: Scalars['Int']['output'];
  remainingArea?: Maybe<Scalars['Int']['output']>;
  remainingProgress: Scalars['Int']['output'];
  remainingTime?: Maybe<Scalars['Int']['output']>;
  step?: Maybe<Scalars['Int']['output']>;
  stepCount?: Maybe<Scalars['Int']['output']>;
  stepEstimatedEndTime?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type RobotTaskProgressSubscriptionInput = {
  cleanedArea?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  deviceTaskId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  progress?: InputMaybe<Scalars['Int']['input']>;
  remainingArea?: InputMaybe<Scalars['Int']['input']>;
  remainingProgress?: InputMaybe<Scalars['Int']['input']>;
  remainingTime?: InputMaybe<Scalars['Int']['input']>;
  step?: InputMaybe<Scalars['Int']['input']>;
  stepCount?: InputMaybe<Scalars['Int']['input']>;
  stepEstimatedEndTime?: InputMaybe<Scalars['String']['input']>;
  subscriptionMode?: InputMaybe<SubscriptionMode>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type RobotTaskProgressUpdate = {
  __typename?: 'RobotTaskProgressUpdate';
  cleanedArea?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  deviceTaskId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  remainingArea?: Maybe<Scalars['Int']['output']>;
  remainingProgress?: Maybe<Scalars['Int']['output']>;
  remainingTime?: Maybe<Scalars['Int']['output']>;
  step?: Maybe<Scalars['Int']['output']>;
  stepCount?: Maybe<Scalars['Int']['output']>;
  stepEstimatedEndTime?: Maybe<Scalars['String']['output']>;
  subscriptionMode?: Maybe<SubscriptionMode>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type RobotTaskSubscriptionInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  estimatedEndTime?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  mapId?: InputMaybe<Scalars['String']['input']>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  remainingTime?: InputMaybe<Scalars['Int']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DeviceTaskStatusEnum>;
  subName?: InputMaybe<Scalars['String']['input']>;
  subscriptionMode?: InputMaybe<SubscriptionMode>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type RobotTaskUpdate = {
  __typename?: 'RobotTaskUpdate';
  createdAt?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  estimatedEndTime?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  mapId?: Maybe<Scalars['String']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  remainingTime?: Maybe<Scalars['Int']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  status?: Maybe<DeviceTaskStatusEnum>;
  subName?: Maybe<Scalars['String']['output']>;
  subscriptionMode?: Maybe<SubscriptionMode>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type RobotTasks = {
  __typename?: 'RobotTasks';
  nodes: Array<RobotTask>;
  pageInfo: PaginationMetadata;
};

export type Role = {
  __typename?: 'Role';
  createdAt: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isReadOnly: Scalars['Boolean']['output'];
  minUsers: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  permissions: Permissions;
  roleCategory: RoleCategoryEnum;
  scopes?: Maybe<Array<Scalars['ID']['output']>>;
  updatedAt: Scalars['String']['output'];
  userAccessLevel: AssetPermissionEnum;
};

export enum RoleCategoryEnum {
  Custom = 'CUSTOM',
  Manager = 'MANAGER',
  Member = 'MEMBER',
  Restricted = 'RESTRICTED',
  Viewer = 'VIEWER'
}

export type RoleListItem = {
  __typename?: 'RoleListItem';
  createdAt: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isReadOnly: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  roleCategory: RoleCategoryEnum;
  scopes: Array<Scalars['ID']['output']>;
  updatedAt: Scalars['String']['output'];
  userAccessLevel: AssetPermissionEnum;
};

export type RolePermissionsInput = {
  deviceGroupManagement: AssetPermissionEnum;
  deviceManagement: AssetPermissionEnum;
  mapGroupManagement: AssetPermissionEnum;
  mapManagement: AssetPermissionEnum;
  userManagement: AssetPermissionEnum;
};

export type Roles = {
  __typename?: 'Roles';
  nodes: Array<RoleListItem>;
};

export type Route = {
  __typename?: 'Route';
  createdAt: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  deviceId: Scalars['String']['output'];
  duration?: Maybe<Scalars['String']['output']>;
  endLandmark?: Maybe<Scalars['String']['output']>;
  expectedPath?: Maybe<RoutePath>;
  id: Scalars['ID']['output'];
  map?: Maybe<RouteMap>;
  materialNumber: Scalars['String']['output'];
  name: Scalars['String']['output'];
  postChargingDuration?: Maybe<Scalars['String']['output']>;
  robotRouteId: Scalars['Int']['output'];
  serialNumber: Scalars['String']['output'];
  startLandmark?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnailS3FilePath?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type RouteConnection = {
  __typename?: 'RouteConnection';
  nodes: Array<Maybe<Route>>;
  pageInfo: PageInfo;
};

export type RouteMap = {
  __typename?: 'RouteMap';
  image: Scalars['String']['output'];
  metadata: RouteMapMetadata;
};

export type RouteMapMetadata = {
  __typename?: 'RouteMapMetadata';
  freeThresh: Scalars['Float']['output'];
  image: Scalars['String']['output'];
  negate: Scalars['Int']['output'];
  occupiedThresh: Scalars['Float']['output'];
  origin: Array<Scalars['Float']['output']>;
  resolution: Scalars['Float']['output'];
};

export type RouteOrder = {
  direction: OrderDirection;
  field: RouteOrderField;
};

export enum RouteOrderField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

export type RoutePath = {
  __typename?: 'RoutePath';
  x: Array<Scalars['Float']['output']>;
  y: Array<Scalars['Float']['output']>;
};

export type Routine = {
  __typename?: 'Routine';
  anonymous: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  deviceId: Scalars['String']['output'];
  duration?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  materialNumber: Scalars['String']['output'];
  name: Scalars['String']['output'];
  postChargingDuration?: Maybe<Scalars['String']['output']>;
  robotRoutineId: Scalars['Int']['output'];
  routeIds: Array<Scalars['Int']['output']>;
  serialNumber: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type RoutineConnection = {
  __typename?: 'RoutineConnection';
  nodes: Array<Maybe<Routine>>;
  pageInfo: PageInfo;
};

export type RoutineOrder = {
  direction: OrderDirection;
  field: RoutineOrderField;
};

export enum RoutineOrderField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

export type SavedWifis = {
  __typename?: 'SavedWifis';
  ssid: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export enum ScheduleStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export enum ScheduleSuctionEnum {
  Boost = 'BOOST',
  Eco = 'ECO',
  Normal = 'NORMAL'
}

export enum ScheduleType {
  KiraB = 'KIRA_B',
  KiraCv50 = 'KIRA_CV50'
}

export type Scope = {
  __typename?: 'Scope';
  createdAt: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isEMScope: Scalars['Boolean']['output'];
  isGlobalScope: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ScopeDetail = {
  __typename?: 'ScopeDetail';
  assetPermission: AssetPermissionEnum;
  createdAt: Scalars['String']['output'];
  deviceGroups: Array<ScopeDetailDeviceGroup>;
  isEMScope: Scalars['Boolean']['output'];
  isGlobalScope: Scalars['Boolean']['output'];
  mapGroups: Array<ScopeDetailMapGroup>;
  name: Scalars['String']['output'];
  roles: Array<ScopeDetailRole>;
  scopeId: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ScopeDetailDevice = {
  __typename?: 'ScopeDetailDevice';
  assetPermission: AssetPermissionEnum;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ScopeDetailDeviceGroup = {
  __typename?: 'ScopeDetailDeviceGroup';
  assetPermission: AssetPermissionEnum;
  devices: Array<ScopeDetailDevice>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ScopeDetailMap = {
  __typename?: 'ScopeDetailMap';
  assetPermission: AssetPermissionEnum;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ScopeDetailMapGroup = {
  __typename?: 'ScopeDetailMapGroup';
  assetPermission: AssetPermissionEnum;
  id: Scalars['ID']['output'];
  maps: Array<ScopeDetailMap>;
  name: Scalars['String']['output'];
};

export type ScopeDetailRole = {
  __typename?: 'ScopeDetailRole';
  assetPermission: AssetPermissionEnum;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  roleCategory: RoleCategoryEnum;
  users: Array<ScopeDetailUser>;
};

export type ScopeDetailUser = {
  __typename?: 'ScopeDetailUser';
  assetPermission: AssetPermissionEnum;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ScopeDevice = {
  __typename?: 'ScopeDevice';
  id: Scalars['ID']['output'];
  materialNumber: Scalars['String']['output'];
  name: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
};

export type ScopeDeviceGroup = {
  __typename?: 'ScopeDeviceGroup';
  devices: Array<ScopeDevice>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ScopeListItem = {
  __typename?: 'ScopeListItem';
  assetPermission: AssetPermissionEnum;
  createdAt: Scalars['String']['output'];
  isEMScope: Scalars['Boolean']['output'];
  isGlobalScope: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  roles: Array<ScopeRoleStats>;
  scopeId: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
  userCount: Scalars['Int']['output'];
};

export type ScopeMap = {
  __typename?: 'ScopeMap';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ScopeMapGroup = {
  __typename?: 'ScopeMapGroup';
  id: Scalars['ID']['output'];
  maps: Array<ScopeMap>;
  name: Scalars['String']['output'];
};

export type ScopeMembership = {
  __typename?: 'ScopeMembership';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  roleId: Scalars['ID']['output'];
  roleName: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type ScopeMutationResponse = {
  __typename?: 'ScopeMutationResponse';
  createdAt: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  deviceGroups: Array<ScopeDeviceGroup>;
  id: Scalars['ID']['output'];
  isEMScope: Scalars['Boolean']['output'];
  isGlobalScope: Scalars['Boolean']['output'];
  mapGroups: Array<ScopeMapGroup>;
  memberships: Array<ScopeMembership>;
  name: Scalars['String']['output'];
  successful?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type ScopeRoleStats = {
  __typename?: 'ScopeRoleStats';
  name: Scalars['String']['output'];
  roleId: Scalars['ID']['output'];
};

export type ScopeSummary = {
  __typename?: 'ScopeSummary';
  customerId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isEMScope?: Maybe<Scalars['Boolean']['output']>;
  isGlobalScope?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type Scopes = {
  __typename?: 'Scopes';
  nodes: Array<ScopeListItem>;
};

export type ScopesMutationResponse = {
  __typename?: 'ScopesMutationResponse';
  nodes: Array<ScopeMutationResponse>;
  successful?: Maybe<Scalars['Boolean']['output']>;
};

export type SetScheduleActiveInput = {
  active: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export type SetScopeNameInput = {
  name: Scalars['String']['input'];
  scopeId: Scalars['ID']['input'];
};

export type ShortUser = {
  __typename?: 'ShortUser';
  assetPermission: AssetPermissionEnum;
  customerId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
};

export type StartCleaningCommandInput = {
  cleaningZones?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mapId: Scalars['String']['input'];
  materialNumber: Scalars['String']['input'];
  mode?: InputMaybe<CleaningSuctionEnum>;
  preset?: InputMaybe<Scalars['String']['input']>;
  serialNumber: Scalars['String']['input'];
  spot?: InputMaybe<CleaningSpotInput>;
};

export type StartFirmwareUpdate = {
  __typename?: 'StartFirmwareUpdate';
  successful?: Maybe<Scalars['Boolean']['output']>;
};

export type StartFirmwareUpdateInput = {
  materialNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export type StopCleaningCommandInput = {
  materialNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
  shouldReturnHome: Scalars['Boolean']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  claimedDevice?: Maybe<ClaimDeviceSubscription>;
  cleaningSchedule?: Maybe<CleaningScheduleUpdate>;
  cleaningTask?: Maybe<RobotTaskUpdate>;
  cleaningTaskProgress?: Maybe<RobotTaskProgressUpdate>;
  device?: Maybe<DeviceUpdate>;
  deviceFirmwareUpdate?: Maybe<DeviceFirmwareUpdateSubscription>;
  deviceGroups: DeviceGroupUpdate;
  deviceLocation?: Maybe<DeviceLocationUpdate>;
  deviceMapPosition?: Maybe<DeviceMapPositionUpdate>;
  firmwareUpdate?: Maybe<FirmwareUpdateSubscription>;
  mapGroups: PraSubMapGroups;
  maps?: Maybe<PraSubMaps>;
  notification?: Maybe<NotificationUpdate>;
  permissionUpdate?: Maybe<PermissionUpdate>;
  scheduleChanged?: Maybe<CleaningScheduleV2>;
  unclaimedDevice?: Maybe<UnclaimDeviceSubscription>;
  user?: Maybe<UserUpdate>;
};


export type SubscriptionClaimedDeviceArgs = {
  customerId: Scalars['String']['input'];
  deviceId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionCleaningScheduleArgs = {
  customerId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  mapId?: InputMaybe<Scalars['String']['input']>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionCleaningTaskArgs = {
  materialNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};


export type SubscriptionCleaningTaskProgressArgs = {
  deviceTaskId: Scalars['String']['input'];
};


export type SubscriptionDeviceArgs = {
  customerId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionDeviceFirmwareUpdateArgs = {
  customerId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type SubscriptionDeviceGroupsArgs = {
  customerId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionDeviceLocationArgs = {
  deviceId: Scalars['ID']['input'];
};


export type SubscriptionDeviceMapPositionArgs = {
  deviceId: Scalars['ID']['input'];
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionFirmwareUpdateArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  firmwareReleaseId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionMapGroupsArgs = {
  customerId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionMapsArgs = {
  associatedDeviceMaterialNumber?: InputMaybe<Scalars['String']['input']>;
  associatedDeviceSerialNumber?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  deviceId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionNotificationArgs = {
  customerId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  notificationId?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionPermissionUpdateArgs = {
  customerId: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type SubscriptionScheduleChangedArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  mapId?: InputMaybe<Scalars['String']['input']>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionUnclaimedDeviceArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionUserArgs = {
  customerId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SubscriptionInput = {
  categories: Array<NotificationCategoryTypeEnum>;
  deviceToken: Scalars['String']['input'];
};

export enum SubscriptionMode {
  Delete = 'DELETE',
  Insert = 'INSERT',
  Update = 'UPDATE',
  Upsert = 'UPSERT'
}

export type SuccessfulResponse = {
  __typename?: 'SuccessfulResponse';
  successful: Scalars['Boolean']['output'];
};

export enum SupportCategoryEnum {
  AppProblem = 'APP_PROBLEM',
  DeviceMalfunction = 'DEVICE_MALFUNCTION',
  FeatureRequest = 'FEATURE_REQUEST',
  Other = 'OTHER',
  TechnicalIssue = 'TECHNICAL_ISSUE'
}

export enum SupportOsEnum {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type SupportRequestInput = {
  appVersion: Scalars['String']['input'];
  category: SupportCategoryEnum;
  countryCode: Scalars['String']['input'];
  description: Scalars['String']['input'];
  deviceId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  osType: SupportOsEnum;
  osVersion: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};

export type SupportRequestResponse = {
  __typename?: 'SupportRequestResponse';
  success: Scalars['Boolean']['output'];
};

export type TimestampFilterInput = {
  lastTimestamp?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type UnassociateDevicesToMapInput = {
  id: Scalars['ID']['input'];
  unassociatedDevices: Array<AssociatedDevicesInput>;
};

export type UnassociateDevicesToMapResponse = {
  __typename?: 'UnassociateDevicesToMapResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UnassociateMapsToGroupInput = {
  id: Scalars['ID']['input'];
  mapIds: Array<Scalars['ID']['input']>;
};

export type UnassociateMapsToGroupResponse = {
  __typename?: 'UnassociateMapsToGroupResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UnclaimDeviceInput = {
  materialNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export type UnclaimDeviceSubscription = {
  __typename?: 'UnclaimDeviceSubscription';
  customerId?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  subscriptionMode?: Maybe<SubscriptionMode>;
};

export type UnclaimDeviceSubscriptionInput = {
  customerId: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  materialNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
  subscriptionMode?: InputMaybe<SubscriptionMode>;
};

export type UnclaimedDevice = {
  __typename?: 'UnclaimedDevice';
  deleted: Scalars['Boolean']['output'];
};

export type UniqueDeviceInput = {
  materialNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export type UpdateCustomRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<RolePermissionsInput>;
  roleId: Scalars['ID']['input'];
};

export type UpdateDeviceGroupInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateMapInput = {
  associatedDevices?: InputMaybe<Array<InputMaybe<AssociatedDevicesInput>>>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  mapId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRolePermissionsInput = {
  deviceGroupManagement?: InputMaybe<AssetPermissionEnum>;
  deviceManagement?: InputMaybe<AssetPermissionEnum>;
  mapGroupManagement?: InputMaybe<AssetPermissionEnum>;
  mapManagement?: InputMaybe<AssetPermissionEnum>;
  roleId: Scalars['ID']['input'];
  userManagement?: InputMaybe<AssetPermissionEnum>;
};

export type UpdateScheduleInput = {
  applyToFollowing?: InputMaybe<Scalars['Boolean']['input']>;
  cleaningZones?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  mapId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  occurrence?: InputMaybe<Scalars['String']['input']>;
  routeId?: InputMaybe<Scalars['ID']['input']>;
  routineId?: InputMaybe<Scalars['ID']['input']>;
  rrule: Scalars['String']['input'];
  suction?: InputMaybe<CleaningSuctionEnum>;
};

export type User = {
  __typename?: 'User';
  customerId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  memberships: Array<Membership>;
  userActions: UserActions;
};

export type UserActions = {
  __typename?: 'UserActions';
  device: DeviceActions;
  deviceGroup: DeviceGroupActions;
  location: LocationActions;
  map: MapActions;
  mapGroup: MapGroupActions;
  user: UserManagementActions;
};

export type UserAssetPermission = {
  __typename?: 'UserAssetPermission';
  assetPermission: AssetPermissionEnum;
};

export type UserCustomer = {
  __typename?: 'UserCustomer';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  users: Array<ShortUser>;
};

export type UserGroup = {
  __typename?: 'UserGroup';
  createdAt?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  customerId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  memberships: Array<Membership>;
  userActions: UserActions;
  userId: Scalars['String']['output'];
};

export type UserInput = {
  customerId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  subscriptionMode?: InputMaybe<SubscriptionMode>;
};

export type UserManagementActions = {
  __typename?: 'UserManagementActions';
  canInvite: Scalars['Boolean']['output'];
  canRemove: Scalars['Boolean']['output'];
  canView: Scalars['Boolean']['output'];
  mustSelectScope: Scalars['Boolean']['output'];
};

export type UserNotification = {
  __typename?: 'UserNotification';
  deviceToken: Scalars['String']['output'];
  language: Scalars['String']['output'];
};

export type UserNotificationUpdateInput = {
  deviceToken: Scalars['String']['input'];
  language: Scalars['String']['input'];
};

export type UserRole = {
  __typename?: 'UserRole';
  customerId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isReadOnly: Scalars['Boolean']['output'];
  isRemoveAble: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  roleCategory?: Maybe<RoleCategoryEnum>;
};

export type UserUpdate = {
  __typename?: 'UserUpdate';
  customerId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  subscriptionMode?: Maybe<SubscriptionMode>;
};

export type ValidateCustomerInvitation = {
  __typename?: 'ValidateCustomerInvitation';
  successful: Scalars['Boolean']['output'];
};

export type ValidateInvitationInput = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  invitationCode: Scalars['String']['input'];
};

export type ValidatedClaiming = {
  __typename?: 'ValidatedClaiming';
  deviceType?: Maybe<DeviceTypeName>;
  validationResult: ClaimingValidationResultEnum;
};
